/* eslint-disable */
/* 当前文件对应的国际化词库版本号: 9.7.1.202610281555 */
export default {
AbandonPaymentConfirm: "Are you sure you want to abandon payment?",
AboutUs: "About Us",
AcceptanceScope: "Service Scope",
AccordingTo12306TicketsCanOnlyBePurchasedAfterThePhoneNumberHasBeenVerified: "According to 12306 regulations, tickets can only be purchased after mobile number verification.",
AccordingToDiDiComplianceCarServiceNeedsRedirectToDiDi: "Due to DiDi compliance requirements, ride booking will redirect you to the DiDi platform.",
AccordingToYourCompanysTravelPolicy: "According to your company's travel policy, you have not selected the lowest fare class flight.",
Account: "Account",
AccountCancel: "Delete Account",
AccountCancelAssetRightsReminder: "After deleting your account, all associated assets and benefits will be forfeited.",
AccountCancelCannotRecoverCaution: "Deleted accounts cannot be recovered. Please proceed with caution.",
AccountCancelConfirmQuestion: "Are you sure you want to delete this account?",
AccountCancelConfirmReminder: "For your protection, please confirm again:",
AccountCanceled: "Account Deleted",
AccountLogin: "Account Login",
AccountName: "Account Holder Name",
AccountNotExist: "Username does not exist",
AccountNumber: "Billing No.",
AccountNumber_1: "Account",
AccountOperations: "Link mobile phone, change password, etc.",
AccountProtocol: "Account Authorization Agreement",
AccountProtocol_1: "I have read and agree to the Account Authorization Agreement",
AccountProtocol_2: "The information you provide, including your name, mobile number, and ID number, will be used for 12306 account password recovery and additional verification services. For details, please refer to the Account Authorization Agreement.",
AccountProtocol_3: "According to railway real-name regulations, valid ID information is required when purchasing train tickets and related services. Your information will be used for ticket booking, travel, refunds, changes, and invoice services. We protect your information through encryption and only share it with authorized third parties when necessary. For details, please refer to the Personal Information Authorization Statement and Instructions for Booking Train Tickets.",
AccountProtocol_3_key_1: "Personal Information Authorization Statement",
AccountProtocol_3_key_2: "Instructions for Booking Train Tickets",
AccountSecurity: "Account Security",
AccountVerification12306: "12306 Account Verification",
AccountVerification12306Desc: "Railway regulations require real-name verification for ticket purchases. Please choose one of the following verification methods.",
AccuratelyFillInTheAgeOfEachChildForSpecialOffers: "Please enter each child's age accurately so we can find the most suitable room options and special offers for you.",
AContactAlreadyExistsWithTheSamePhoneNumber: "A contact with this mobile phone already exists",
ActivityNotice: "Event Notification",
ActivityNoticeDesc: "Promotional Offers Reminder",
ActualPayment: "Amount Paid",
Add: "Add",
AddAnotherTrip: "Add Another Train",
AddBusiness: "Add (Business Trip)",
AddContact: "Add Contact",
AddCostCenter: "Add Cost Center",
AddDesignatedApprover: "Add Designated Approver",
Added: "Added",
AddEmergencyContact: "Add Emergency Contact",
AddEmergencyContactPrompt: "After adding an emergency contact, trip information will be automatically shared via SMS when you use one-tap emergency assistance.",
AddFailed: "Failed to add",
AddFlight: "Add Segment",
AddFrequentContacts: "Add Frequent Contacts",
AddFrequentTraveller: "Add as Frequent Traveler",
AddInvoiceHeader: "Add Invoice Title",
AdditionalTaxesFees: "Additional Taxes/Fees",
AddManually: "Add Manually",
AddNewReimbursementInvoiceTitle: "Add Reimbursement Invoice Title",
AddPassenger: "Add Traveler",
AddPersonal: "Add (Personal Use)",
Address: "Full Address",
AddressDistrict: "Region",
AddReturnTrip: "Add Return Trip",
AddRoute: "Add Trip",
AddSecurityExplain: "Add protection for your family's peace of mind",
AddSecurityExplain_1: "Travel with protection for greater peace of mind",
AddSucceed: "Added successfully",
AddTiedList: "Add to Linked Accounts",
AddTravelCard: "Add Frequent Flyer Card",
AddTraveler: "Add +",
AdministrativeDistrict: "District",
AdmissionPolicy: "Check-in Policy",
Adults: "Adults",
AdultsDesc: "Age 12+",
AfterClickingGoToPay: "After clicking Pay, open WeChat and use Scan to pay with the QR code.",
AfterClickingGoToPay_1: "After clicking Pay, open Alipay and use Scan to pay with the QR code.",
AfterLanding: "After Landing",
AfterSendingTextMessage: "After sending the SMS, you will receive a 6-digit verification code from 12306. Please enter the code.",
AgentNoResponse: "Assistant unavailable. Please try again later.",
AggregatedCarService: "Ride Booking",
Agree: "Agree",
AgreeAndContinue: "Agree and Continue",
Agreement: "Negotiated Rate",
AgreementDesc: "Negotiated Details",
AgreementHotels: "Negotiated Hotels",
AgreementHotelStarRating: "Negotiated Hotel Rating",
AgreementHotelTotal: "Negotiated Hotel Total",
AgreementHotelTotalRoomNight: "Negotiated Room Nights",
AgreementNight: "Negotiated Room Nights",
AIAssistant: "AI Assistant",
AIAssistantAnswering: "AI Assistant is responding, please try again later",
AIBooking: "AI Booking",
AIFillAssistant: "AI Form Assistant",
AirChinaPassengerBaggageDomesticTransportationGeneralConditions: "Air China General Conditions of Carriage (Domestic, 2017, CN Version)",
AirfareYouSearchedFor: "Recent Flight Searches",
Airline: "Airlines",
AirlineList: "Airlines",
AirlinePassengerMaintenance: "Airline Passenger Rules Under Maintenance",
AirLowestFareAcceptance: "Lowest Fare Booking Rate",
Airport: "Airport",
AirportDropOff: "Airport Drop-off",
AirportPickup: "Airport Pick-up",
AirportPickupDropoff: "Airport Transfer",
AirportStation: "Airport / Station",
AirportTerminal: "Terminal",
AirportTransferService: "Airport Transfer Service",
AirRouteAnalysis: "Route Analysis (Economy Only)",
AirRouteAndCarrierAnalysis: "Route & Airline Analysis",
AirTicketBookingInstructions: "Flight Booking Instructions",
AirTicketConsumptionInDifferentCities: "Flight Spend by City",
AirTickets: "Airfare",
Aisle: "Aisle",
AIXiaoShun: "Homsom AI Assistant",
AlarmTripInfoShare: "Trip information will be automatically shared with your emergency contact via SMS after an alert is triggered",
Album: "Album",
AliPay: "Alipay Payment",
Alipay: "Alipay",
AlipayAccount: "Alipay Account",
AlipayAccountFormatError: "Invalid Alipay account format",
AlipayAuthDescription: "Redirect to Alipay to authorize and activate Enterprise Code",
AlipayAuthorization: "Alipay Authorization",
All: "All",
AllBookings: "My Bookings",
AllCabins: "All Cabins",
AllCollection: "All Favorites",
AllCompanyPayment: "Corporate Payment",
AllLoaded: "All Content Loaded",
AllOrdersForRecentOneMonth: "Showing travel requests from the last 6 months",
AllOrdersForRecentOneYear: "All orders displayed",
AllOrdersForRecentOneYear_1: "Showing all orders from the last year",
AllOrdersForRecentSixMonths: "Showing all orders from the last 6 months",
AllowRecordPermission: "Please allow microphone permission",
AlreadyHave12306Account: "Already have a 12306 account",
AlreadySetting: "Configured",
AlsoAvailableBy: "Also Available",
Amount: "Amount",
Amount_1: "Amount (Tax Included)",
AmountOfBillForTheCurrentPeriod: "Current Bill Amount",
AmountOfConsumption: "Amount Spent",
AmountPaidInThisPeriod: "Amount Paid",
AmountPayableInTheCurrentPeriod: "Amount Due",
AndroidPersonalizedRecommendation: "Personalized Recommendations",
AndroidPersonalizedRecommendationDesc: "Provide personalized recommendations to improve your booking experience",
AndroidSettingPrivacy: "Privacy Settings",
Announcement: "Announcements",
AnnouncementInformation: "Announcement Details",
Any: "Any",
AnyCity: "Any City",
Appearance: "Appearance",
Applicant: "Applicant",
ApplicantForRefund: "Refund Requester",
Application: "Request",
ApplicationContent: "Request Details",
ApplicationDate: "Request Date",
ApplicationForApproval: "Submit for Approval",
ApplicationForBook: "Book via Request Form",
ApplicationIntlFlight: "International Flight Request",
ApplicationIntlHotel: "Overseas Hotel Request",
ApplicationNumber: "Request No.",
ApplicationToReservedNoData: "No Request Forms Available",
Apply: "Apply",
ApplyForRefund: "Refund",
ApplyRefund: "Refund",
ApplyRefundOrder: "Refund",
ApplyReschedule_1: "Reschedule",
ApplyTime: "Application Time",
ApplyTravel: "Business Trip Request",
ApplyTravelCitys: "Business Trip City",
ApplyTravelConfirm: "Business Trip Confirmation",
ApplyTravelNeeds: "Trip Requirements",
ApplyTravelSegment: "Trip Details",
ApplyTravelTime: "Trip Date",
ApproachingTakeoff: "Approaching Takeoff",
ApprovalExpired: "Expired",
ApprovalFail: "Approval Failed",
ApprovalFlow: "Approval Flow",
ApprovalInformation: "Approval Information",
ApprovalInformationDesc: "Approval Status Alerts",
ApprovalProcess: "Approval Process",
ApprovalRejected: "Rejected",
ApprovalRejection: "Rejected",
ApprovalRemarks: "Approval Comments",
Approvals: "Approval",
Approvals_1: "My Approvals",
ApprovalSetting: "Approval Settings",
ApprovalStatus: "Approval Status",
ApprovalSubmitted: "Submitted",
ApprovalTemplate: "Approval Templates",
ApprovalTemplate_1: "My Templates",
ApprovalTemplateConfig: "Approval Template Configuration",
ApprovalTemplateDetails: "Template Details",
ApprovalType: "Approval Method",
ApprovalType_1: "Approval Type",
ApprovalWhitelist: "Approval Whitelist",
Approved: "Approved",
ApprovedCanceled: "Request Canceled",
ApprovedPass: "Approved",
Approver: "Approver",
ApproversHaveBeenBound: "Approver Linked",
ApproxPay: "Approx.",
Area: "Area",
AreYouSureToAddThisAsAFrequentTraveler: "Add as frequent traveler?",
AreYouSureToCancelTheOrder: "Are you sure you want to cancel this order?",
AreYouSureToCancelUnableToSave: "Your changes have not been saved. Are you sure you want to leave?",
AreYouSureToChange: "Are you sure you want to change your ticket?",
AreYouSureToChangeTheCurrency: "Change currency?",
AreYouSureToChangeTheLanguage: "Change language?",
AreYouSureToChangeYourFlightToTheCheapestFlight: "Switch to the lowest priced flight?",
AreYouSureToDelete: "Are you sure you want to delete?",
AreYouSureToDeleteTheApprover: "Delete this approver?",
AreYouSureToDeleteTheCertificate: "Delete this document?",
AreYouSureToDeleteTheEmployeeFromTheWhitelist: "Remove employee from whitelist?",
AreYouSureToDeleteTheRC: "Delete this Reason Code?",
AreYouSureToDeleteTheSelectedCollection: "Delete selected favorites?",
AreYouSureToDeleteThisCustom: "Delete this custom item?",
AreYouSureToDeleteThisEmployeeFromTheTemplate: "Remove employee from template?",
AreYouSureToPayForThisOrder: "Proceed to payment for this order?",
AreYouSureToRemoveItFromTheCostCenterList: "Delete this cost center?",
AreYouSureToRemoveItFromTheDepartmentsList: "Delete this department?",
AreYouSureToRemoveItFromTheEmployeeList: "Remove from employee list?",
AreYouSureToRemoveItFromTheFrequentTravelerList_1: "Remove from Frequent Travelers? (This only removes the traveler from your Frequent Travelers list; it does not delete employee data. To delete employee data, go to [Management > Employee Management] or contact your dedicated Business Travel advisor.)",
AreYouSureToRemoveItFromTheFrequentTravellerList: "Remove from frequent travelers?",
AreYouSureToRemoveItFromTheNonEmployeeList: "Remove from external personnel list?",
AreYouSureToRescheduled: "Are you sure you want to change your dates?",
AreYouSureToSeat: "Confirm seat selection?",
AreYouSureToSubmit: "Confirm submission?",
AreYouSureToSubmitAndPayForTheOrder: "Submit and pay for the order?",
AreYouSureToSubmitYourOrder: "Submit order?",
AreYouSureToTurnOffFaceIDLogin: "Turn off Face ID login?",
AreYouSureYouWantToDeleteThisAccount: "Delete account?",
AreYouSureYouWantToLogout: "Sign out?",
AreYouSurYouWantToDeleteThisAccount: "Delete account?",
AreYouSurYouWantToLogout: "Sign out?",
AreYouSurYouWantToUntieThisAccount: "Unlink account?",
Arrival: "Arr.",
ArrivalCity: "Arrival City",
ArrivalCityAddress: "Going to",
ArrivalCityAddressDesc: "All transit cities must be added to your destinations.",
ArrivalCityOptions: "Optional Arrival Cities",
ArrivalDate: "Arrival Date",
ArrivalEarliest: "Arrival(Earliest)",
ArrivalLatest: "Arrival(Latest)",
ArrivalStation: "Arrival Station",
ArrivalStation_1: "Arrival Station",
ArrivalTerminal: "Arrival Terminal",
ArrivalTime: "Arrival Time",
ArrivalTime_1: "Arrival Time",
ArrivalTime_2: "Arrival Station/Time",
ArrivalTimeDepartureDate: "Arrival Time/Check-out Date",
ArrivalTimeIsLocalTime: "All flight times are local.",
Arrive: "Drop-off",
ArriveAddress: "Drop-off Location",
Associated12306Account: "Link 12306 Account",
AtNoonToday: "12:00 PM Today",
AttachFile: "Attachments",
AttachFileUploadExplain_1: "• Up to 10 files can be uploaded, with each file size not exceeding 8MB.",
AttachFileUploadExplain_2: "• Supported file formats: img, word, ppt, excel, pdf",
AUD: "AUD",
Authentication: "Identity Verification",
AuthenticationProtocol: "Verification Agreement",
AuthenticationProtocol_1: "I have read and agree to the Verification Agreement",
AuthResultNotFound: "Authorization result not found. Please confirm activation in Alipay.",
AutoCorrect: "Auto-correct",
AutoCorrectIdentityInfo: "The following information has been automatically corrected based on ID card",
Available: "Available",
AvailableIntegral: "Available Points",
AvailableTickets: "Available",
AverageBusinessTravelFare: "Avg. Fare",
AverageDiscount: "Avg. Discount",
AverageDomesticDiscount: "Avg. Domestic Discount (Economy)",
AverageHotelPrice: "Avg. Room Rate",
AverageMileagePrice: "Avg. Price per Mile (Economy)",
AverageNumberOfDaysBookedInAdvance: "Avg. Days Booked in Advance",
AveragePrice: "Avg. Price",
AveragePriceOfBusinessTravelAgreement: "Avg. Negotiated Rate",
AveragePriceOfBusinessTravelMileage: "Avg. Price per Mile",
AverageTicketPrice: "Avg. Fare",
AverageTrainTicketPrice: "Avg. Train Fare",
AVerificationMessagePleaseEnterTheVerificationCodeYouReceived: "Verification code sent. Please enter the code to proceed.",
AvgTicketPriceOfMileage: "Avg. Price per Mile",
AwaitingConfirmation: "Pending",
AwayFrom: "Distance",
Baby: "Infants",
BabyDesc: "14 days - under 2 years old",
BabyNonBookable: "Unavailable for Infants",
BabyNonSupportBookable: "To book tickets for infants, please contact your travel consultant.",
BabyReQuery: "This flight does not accept infant bookings. Please search for other available flights.",
BabyTooSmallNonBookable: "Infants under 14 days old cannot be booked.",
BabyWith: "With Infants",
BabyYearsOld: "14 days - 2 years old",
Back: "Back",
BackFlight: "Return Flight",
BackModify: "Back to Edit",
BackToHome: "Back to Home",
BackToHotelList: "Back to Hotels",
BackToLogin: "Back to Login",
Baggage: "Baggage",
BaggageCarousel: "Baggage Claim",
BaggagePolicy: "Baggage Policy",
Balance: "Balance",
Bank: "Bank Name",
BankAccount: "Account",
BankCardInformation: "Credit Card Info",
BasicInformation: "Basic Info",
BasicInformationIsIncompletePleaseEdit: "Incomplete basic info, please complete.",
Batch: "Bulk Edit",
BatchInvoiceIssuing: "Bulk Invoicing",
BatchPass: "Bulk Approve",
BedType: "Bed Type",
BeforeUsingDiDiPlatformPleaseFillCarBookingOrder: "Please complete the pre-order form before using corporate car services.",
BeijingTime: "Beijing Time",
BeingApprovalByTheFlightCompany: "Pending Airline Review",
BeingVerified: "Verifying",
BelongCity: "City",
BeOverdueByCarPleaseCheckAgain: "Vehicle info updated, please search again.",
BeOverdueByFlightPleaseCheckAgain: "Flight info updated, please search again.",
BeOverdueByHotelPleaseCheckAgain: "Hotel info updated, please search again.",
BeOverdueByTrainPleaseCheckAgain: "Train info updated, please search again.",
BigBed: "King/Queen Bed",
BillEndDate: "Billing End Date",
BillGrouping: "Billing Group",
BillingPeriod: "Billing Period",
BillStartDate: "Billing Start Date",
Bind: "Link Now",
BindFailed: "Linking Failed",
Binding: "Link Account",
BindingCTrip: "Link Ctrip Account",
BindingCTripDesc: "We will use your mobile number to link your Ctrip personal account. If you do not have one, Homsom will register a new Ctrip account with this number.",
BindingCTripPrivacy: "I have read and agree to Ctrip's Service Agreement and Privacy Policy",
BindingCustomItems: "Link Custom Fields",
BindingEmployees: "Link Employees",
BindingHuazhu: "Link Huazhu Account",
BindingHuazhuDesc: "We will use your info to link your Huazhu corporate account. If you do not have one, Homsom will register a new Huazhu account with this info.",
BindingHuazhuPrivacy: "I have read and agree to Huazhu's Service Agreement and Privacy Policy",
BindingLogin: "One-Click Link",
BindingMeituan: "Link Meituan Account",
BindingMeituanDesc: "We will use your info to link your Meituan corporate account. If you do not have one, Homsom will register a new Meituan account with this info.",
BindingMeituanPrivacy: "I have read and agree to Meituan's Service Agreement and Privacy Policy",
BindingStatus: "Linking Status",
BindMailbox: "Link Email",
BindMembersToEnjoyLowerPrices: "Link Membership for Lower Prices",
BindSuccessfully: "Linked Successfully",
BindUnbind: "Link/Unlink",
BlankImport: "Blank Template Import",
BoardingGate: "Boarding Gate",
Book_1: "Book",
Book_2: "Book Now",
Book_3: "Book",
BookableNights: "Bookable Room Nights",
BookableTimes: "Bookable Times",
BookAllStaff: "Book for All Staff",
BookCar: "Book Vehicle",
BookDesignatedDepart: "Book for Designated Departments",
BookDesignatedStaff: "Book for Designated Staff",
BookDomesticFlights: "Book Domestic Flights",
BookDomesticHotel: "Book Domestic Hotels",
Booker: "Booker",
BookFinished: "Sold Out",
BookFlight: "Book Flight",
BookHotel: "Book Hotel",
BookInAdvance: "Advance Booking",
Booking: "Book",
BookingApprovalFlow: "Booking Approval Flow",
BookingDaysInAdvance: "Advance Booking Days",
BookingInformation: "Booking Information",
BookingInstructionsAndInstructionsForReturning: "Booking & Refund Policy",
BookingLevel: "Booking Level",
BookingMail: "Booking Email",
BookingMethods: "Booking Method",
BookingPwd: "Booking Password",
BookingRange: "Booking Scope",
BookingSMS: "Booking SMS",
BookingSource: "Booking Source",
BookingSucceed: "Booking Successful",
BookingTheBus: "Book Bus Tickets",
BookingTheCar: "Book a Car",
BookingTheMeals: "Meal Reservation",
BookInternationalFlights: "Book International Flights",
BookInternationalHotel: "Book Overseas Hotels",
BookOnlySelf: "Book for Self Only",
BookPermissions: "Booking Permissions",
BookPwdAbandon: "Abandon",
BookPwdContinuePayment: "Continue Payment",
BookPwdSetPasswordFormatError: "Please enter a 6-digit password",
BookPwdSetPasswordHint: "Please enter 6 digits",
BookTheLowestLogicalFare: "Book Lowest Fare",
BookTrain: "Book Train Tickets",
BookType: "Booking Type",
Bound: "Linked",
BoundCustomItems: "Linked Custom Fields",
BoundEmployees: "Linked Employees",
Brand: "Brand",
BrandSlogan: "Choose Homsom for smoother, smarter business travel",
Breakfast: "Breakfast Included",
Breakfast_1: "Breakfast",
BrowserOpens: "Open in Browser",
Budget: "Budget",
BudgetAmount: "Budget Amount",
BudgetColon: "Budget:",
BulkRejection: "Batch Reject",
Business: "Business",
BusinessCenter: "Business Center",
BusinessClass: "Business",
BusinessConsultant: "Business Consultant",
BusinessConsumptionNoPersonalPayment: "You need to activate the Alipay Enterprise Code to use Enterprise Payment for train ticket bookings on Homsom, no personal advance payment required",
BusinessDistrict: "Business District",
BusinessDistrictInfrastructureBrandEtc: "Business District / Infrastructure / Brand",
BusinessReschedule: "Business Change",
BusinessTravel: "Corporate Travel",
BusinessTravelScale: "Corporate Travel Volume (Monthly)",
BusinessTrip: "Business Trip",
BusinessTripApply: "Business Trip Request",
BusinessTripFormGenerated: "Business Trip Request Created",
BusinessTripFormTravelInfo: "Business Trip Request (Itinerary)",
BusinessTripSchedule: "Business Trip Schedule",
BusinessType: "Business Type",
BusinessType_1: "Business",
BusinessUnit: "Business Unit",
BusOrderConfirmation: "Bus Ticket Order Confirmation",
BusOrderDetails: "Bus Ticket Details",
BusRank: "Bus Fare Standard",
BusRefundOrderConfirm: "Bus Ticket Refund Confirmation",
BusStation: "Bus Station",
BusTicket: "Bus Ticket",
BusTicketOrder: "Bus Ticket Order",
ByMail: "By Email",
ByPhoneNumber: "By Mobile Number",
Cabin: "Cabin",
CabinInformationHasBeenUpdated: "Cabin information updated. Please review and resubmit your order.",
CabinLevel: "Cabin Class",
CabinType: "Cabin Type",
CAD: "CAD",
Calendar: "Calendar",
CallCar: "Ride Hailing",
CallCarNow: "Book Now",
CallingCarCancelConfirm: "We're finding a ride for you. Cancel anyway?",
CallingForYou: "Finding a Ride...",
CallingVehicleForYou: "Finding a Ride",
CallPhone: "Call",
CallTaxiAgain: "Book Again",
CallThePolice: "Call 110",
Camera: "Camera",
CameraPermissionRetryMessage: "Camera permission is required. Open it again?",
CameraPermissionSettingsMessage: "Camera permission is disabled. Please enable it in system settings.",
CameraPermissionUsageMessage: "Used to obtain image data for QR‑code scanning, photo capture and face recognition.",
CameraPermissionUsageTitle: "Camera Permission Usage",
Cancel: "Cancel",
Cancel_1: "Not Now",
Cancel_2: "Cancel Management",
CancelAnyway: "Cancel Anyway",
Canceled: "Canceled",
CancelFailed: "Cancellation Failed",
CancelFee: "Cancellation Fee",
CancelForFree: "Free Cancellation",
CancelInformation: "Cancellation Details",
CancelInquiry: "Cancel Request",
Cancelling: "Canceling...",
CancelOrder: "Cancel Order",
CancelReason: "Cancellation Reason",
CancelRefund: "Cancel Refund",
CancelRoomSelectTitle: "Select Rooms to Cancel",
CancelRules: "Cancellation Policy",
CancelSucceed: "Canceled Successfully",
CannotBeCancelled: "Non-refundable",
CannotBeConvertToPinyin: "Chinese name is required for Pinyin conversion",
CannotOpenAlipayUseQRCode: "Failed to launch Alipay? Please scan the QR code to complete payment",
CannotSelectGuestRepeat: "Cannot select the same guest repeatedly",
CanNotSupportedFileType: "Unsupported File Type",
Car: "Cars",
CarAirport: "Airport Transfers",
CarApplication: "Car Request",
CarbonEmission: "Carbon Emissions",
CarbonOffset: "Carbon Offset",
CardHolder: "Cardholder",
CardholderInformation: "Cardholder Information",
CardNumber: "Card No.",
CardType: "Card Type",
CarFare: "Fare",
CarOrder: "Car Orders",
CarOrderConfirmation: "Car Order Confirmation",
CarPlatform: "Car Service Provider",
CarRank: "Car Policy",
Carrier: "Carrier",
Carrier_1: "Carrier",
CarrierAnalysis: "Carrier Analysis",
CarriersItineraries: "Carriers & Routes",
CarScene: "Usage Scenario",
CarServiceTime: "Pickup Time",
CarTrain: "Train Station Transfers",
CarType: "Vehicle Type",
CellphoneNumber: "Mobile Phone",
CertificateInformation: "ID Information",
Change: "Change",
Change_3: "Switch 12306 Account",
ChangeDetails: "Reschedule Details",
ChangeDetails_1: "Change Details",
ChangeFaceCheck: "Switch Face Verification",
ChangeFailed_1: "Modification Failed",
ChangeFee: "Change Fee",
ChangeFlight: "Change Flight",
ChangeFlightSchedule: "Rescheduled Flight",
ChangeIDNoVerify: "Switch ID Verification",
ChangeInstructions: "Change Policies",
ChangeLoginPwd: "Change Login Password",
ChangeMobileNumber: "Change Mobile Phone",
ChangeMobileNumber_1: "Change Mobile Phone",
ChangePassword: "Change Password",
ChangePolicy: "Change Policies",
ChangeRate: "Change Rate",
ChangeSchedule: "Change Itinerary",
ChangeSegment: "Change Itinerary",
ChangeSegmentDate: "Reschedule",
ChangeSmsCheck: "Switch SMS Verification",
ChangeStation: "Change Arrival Station",
ChangeStationTitle: "Station Change Notice",
ChangeSuccessFailed: "Change Failed",
ChangeYourFlightAndContinueDeparting: "Choose another flight and continue your trip.",
Changing: "Changing",
Charge: "Fee",
ChargebackDateTime: "Refund Request Time",
ChargebackDetails: "Refund Details",
ChargebackNumber: "Refund No.",
ChargebackRoom: "Rooms Canceled",
ChargebackTime: "Cancellation Date",
ChargeByAirlineRefundRules: "Fees are charged according to airline refund/change policies.",
ChargedAccordingToTheCorrespondingAirlineTicketRegulations: "Fees are charged according to the applicable airline ticket rules (NFD).",
CheapestFlight: "Lowest-Priced Flights",
CheapFlights: "Special Fare Flights",
Check: "Verify",
CheckerInformation: "Guest Information",
CheckIn: "Check-in",
CheckInAppOpenOrDownloadTips: "If the app is installed, tap “Open”. If not, tap “Download”, then install the app before checking in.",
CheckInCity: "Check-in City",
CheckInCounter: "Check-in Counter",
CheckInCounterIsClosedNotBookedYet: "Check-in counters are closed. Booking is currently unavailable.",
CheckInDate: "Check-in Date",
CheckInformation: "Check Information",
CheckingForTheLatestPriceForYou: "Checking the latest price for you. Please wait...",
CheckInHotel: "Check in at Hotel",
CheckInRules: "Check-in Policies",
CheckInSeat: "Check In & Seat",
CheckInTime: "Check-in Time",
CheckInViaAppBelow: "You can check in using the app below.",
CheckOrder: "View Order",
CheckOut: "Check-out",
CheckOutDate: "Check-out Date",
CheckRemainRoomType: "View Remaining Room Types",
CheckTheCancellationRules: "View Cancellation Policies",
CheckTheDifference: "View Travel Standard Details",
CHF: "Swiss Franc",
ChildOfAge: "Child's Age",
Children: "Children",
ChildrenAndBabyExplain: "Child and Infant Booking Instructions",
ChildrenDesc: "Ages 2–11",
ChildrenNonBookable: "Children Not Bookable",
ChildrenNonSupportBookable: "To book a child ticket, please contact your travel consultant.",
ChildrenReQuery: "Children cannot be booked on this flight. Please search again for flights that allow children.",
ChildrenWith: "With Children",
ChildrenYearsOld: "Ages 2–12",
China: "Domestic",
China_1: "China (incl. HK/MO/TW)",
China_3: "China",
ChinaRegion: "Domestic (incl. HK/MO/TW)",
ChinaSouthernAirlinesNewRegulations: "China Southern reminder: Passengers may change or refund their tickets via the China Southern app or WeChat and receive refunds directly. If passengers obtain refunds directly from China Southern, your company will still be charged the full original ticket amount. Please ensure proper internal control to avoid risks.",
ChineseName: "Chinese Name",
Choose: "Select",
ChooseAirport: "Select Airport",
ChooseBU: "Select BU",
ChoosePhotos: "Select Photo",
ChooseSnatchSeat_1: "Select High-Speed Rail/Intercity Seats",
ChooseSnatchSeat_2: "Select Standard/Express/Other Seats",
ChooseTheLowestPriceToSave: "Choose Lowest Price",
ChooseTheReason: "Select Reason",
ChooseTrainStation: "Select Train Station",
CICO: "Check-in/Check-out",
CICO_1: "Check-in/Check-out Dates",
City: "City",
City_1: "By Route",
CityAnalysis: "City Analysis",
ClassAnalysis: "Cabin Analysis",
ClassHotel: " Hotel",
ClassRoomTypeSeat: "Cabin/Room Type/Seat",
Clear: "Clear",
ClearAllChat: "Clear All Chats",
ClearCache: "Clear Cache",
ClearFilters: "Clear Filters",
ClearHistory: "Clear History",
ClearHistorySearchRecord: "Clear Search History",
ClearHistorySearchRecordConfirmTip: "Search history cannot be recovered after clearing. Clear now?",
ClearSuccess: "Cleared",
ClickLogin: "Log In",
ClickNextToIndicateThatYouHaveAcceptedAndAreAwareOfTheRefundPolicyForThisTicket: "By tapping “Next”, you accept the refund and change policy for this ticket.",
ClickOptionToChangeDropOffPoint: "Tap to change drop-off location",
ClickOptionToChangePickUpPoint: "Tap to change pickup location",
ClickRefresh: "Refresh",
ClickShrink: "Collapse",
ClickToCopyShareCode: "Copy Code",
ClickToDownloadApp: "Download App",
ClickToOpen: "Tap to Open",
ClickToResend: "Resend",
ClickToSetTheAddress: "Tap to Set Address",
ClickToView: "View",
Close: "Close",
Closed: "Closed",
CloudBill: "Cloud Bill",
CloudQuickPay: "UnionPay",
CO2Emissions: "CO₂ Emissions",
CodeShare: "Codeshare",
Collect: "Favorites",
ComfortHotel: "Comfort Hotels",
ComfortHotel_1: "Comfort",
CommentsDetails: "Review Details",
CommodityDetails: "Product Details",
CommonAddress: "Saved Addresses",
CommonOperations: "Common Actions",
Company: "Company",
CompanyInfo: "Company Information",
CompanyInvoiceHeader: "Company Invoice Title",
CompanyName: "Company Name",
CompanyPayment: "Corporate Payment",
CompanyPaymentPrepay: "Corporate Payment (Prepaid)",
CompanyTel: "Company Phone",
CompleteVerification: "Complete Verification",
ComprehensiveTravelSafety: "Comprehensive Travel Protection",
Confirm: "Confirm",
Confirm_1: "Confirm",
Confirm_2: "Done",
Confirm_3: "Confirm",
ConfirmAndNext: "Confirm & Continue",
ConfirmationOfFirstTimeBookingInformationForPassenger: "First-time Traveler Information Confirmation",
ConfirmationOfFirstTimeBookingInformationForPassengerDesc: "Please confirm traveler information before booking. Tap “Edit” if changes are needed.",
ConfirmationOfFirstTimeBookingInformationForPassengerVehicle: "First-time Traveler Information Confirmation",
ConfirmationOrder: "Confirmation Slip",
ConfirmCancel: "Confirm Cancellation",
ConfirmClearAllChat: "Clear all conversations?",
ConfirmCopyRedirectLink: "Are you sure you want to copy the redirect link?",
ConfirmDelete: "Confirm Delete",
ConfirmDeleteInvoiceTitle: "Delete this invoice title?",
ConfirmDeparture: "Confirm Exit",
ConfirmDropOffPoint: "Confirm Drop-off Point",
Confirmed: "Confirmed",
ConfirmedCallCar: "Confirmed, Book Now",
ConfirmedCheckInTimeAtTheCounterCanBeBooked: "Check-in time confirmed. Continue booking.",
ConfirmedRedirectToDiDiCarHailing: "Confirmed, Redirecting to DiDi",
ConfirmImmediately: "Confirm Now",
Confirming: "Confirming",
ConfirmMail: "Confirmation Email",
ConfirmPay: "Confirm Payment",
ConfirmPickUpPoint: "Confirm Pickup Point",
ConfirmPoint: "Confirm Location",
ConfirmRules: "Confirmation Rules",
ConfirmSelection: "Confirm Selection",
ConfirmSMS: "Confirmation SMS",
ConfirmStartReserveSeat: "Are you sure you want to lock the seat?",
ConfirmSubmission: "Confirm Submission",
ConfirmThatYourDiDiAccountIsLinked: "Confirm your DiDi account is linked?",
ConfirmTheChanges: "Confirm Changes",
ConfirmTheChanges_1: "Confirm Changes",
ConfirmTheNewPassword: "Confirm New Password",
ConfirmTheNewPassword_1: "Confirm Password",
ConfirmTheRemovalOfTheirDocuments: "Remove ID?",
ConfirmToResendApprovalInformation: "Resend approval info?",
ConfirmUnbindEnterpriseCode: "After unlinking, you can no longer use Corporate Code for payment. Are you sure you want to unlink?",
ConfirmUnbinding: "Confirm Unlink?",
ConfirmUpdate: "Confirm Update",
ConfirmVoucherContent: "Confirm Voucher Details",
ConsistentWithIdPinyin: "Match the pinyin on the ID",
Consultant: "Travel Consultant",
ConsumptionOfCarsInDifferentCities: "Car Spend by City",
ConsumptionOfTrainTicketsInEachCity: "Rail Spend by City",
ContactAdministratorToEnable: "Contact admin for access",
ContactCustomerService: "Customer Service",
ContactDetails: "Contact Details",
ContactDriver: "Contact Driver",
ContactHotel: "Contact Hotel",
ContactInfo: "Contact Info",
ContactInformation: "Contact Information",
ContactName: "Contact Name",
ContactNumber: "Contact Number",
ContactNumberColon: "Phone: ",
ContactPhoneNumber: "Contact Mobile Number",
ContactPhoneNumberCannotBeDuplicated: "Contact mobile numbers must be unique.",
Contacts: "Contacts",
ContactsPermissionRetryMessage: "Contacts permission is required. Open it again?",
ContactsPermissionSettingsMessage: "Contacts permission is disabled. Please enable it in system settings.",
ContactsPermissionUsageMessage: "Used to select contacts and retrieve contact information you explicitly choose.",
ContactsPermissionUsageTitle: "Contacts Permission Usage",
ContactUsByPhoneIfFaceRecognitionFails: "Face recognition failed? Call us.",
Content: "Content",
ContentIsEmpty: "Content cannot be empty",
Continue: "Continue",
ContinueBooking: "Continue Booking",
ContinueBooking_1: "Continue Booking",
ContinueBookingFlightTicket: "Continue Flight Booking",
ContinueBookingHotel: "Continue Hotel Booking",
ContinueBookingTrainTicket: "Continue Train Booking",
ContinueBookingWithoutRescheduling: "Keep Date & Continue",
ContinueFlightTicketInquiry: "Continue Flight Quote",
ContinueInput: "Continue",
ContinueIssuingInvoice: "Continue Invoicing",
ContinueManualChange: "Continue",
ContinueManualRefund: "Continue",
ContinueReserveCar: "Continue Car Booking",
ContinueRide: "Continue Ride",
ContinuetoBook: "Continue Booking Original Flight",
ContinueToChange: "Continue Change",
ConvertToPinyin: "To Pinyin",
Copy_1: "Copy",
CopyFailed: "Copy failed",
CopyInvitationInformation: "Copy Invitation Info",
CopyInvitationLink: "Copy Invitation Link",
CopyLink: "Copy PDF Link",
CopyLinkToBrowserForPay: "If payment fails to redirect, please copy the link below to Safari or your browser to complete payment.",
CopyLinkToSafariOrBrowser: "Please copy the link to Safari or default browser to pay",
CopyShareCodeToAlipay: "Copy code to Alipay",
CopySuccess: "Copied",
CopySuccessPasteInAlipay: "Copied successfully. Please paste and open it in Alipay.",
CopyTheLink: "Copy Link",
CopyToClipboard: "Copy to Clipboard",
CorporateTourism: "Corporate Travel",
CostCenter: "Cost Center",
CostCenterName: "Cost Center Name",
CreationDate: "Creation Date",
CreationTime: "Created Time",
Credential: "ID Document",
CreditCard: "Credit Card",
CreditCardGuarantee: "Credit Card Guarantee",
CreditGuarantee: "Credit Guarantee",
CrisisPoliceHelp: "In case of emergency, contact the police.",
CrossRegionCarHailing: "Intercity Ride-Hailing",
Currency: "Currency",
CurrencySelectedIncorrectly: "Invalid currency. Please reselect.",
CurrencySetting: "Currency Settings",
Current: "Current",
CurrentAdvancePayment: "Current Prepayment",
CurrentAvailable: "Currently Available",
CurrentCityNoCarService: "Service unavailable in this city at this time.",
CurrentFld: "Current Voucher Beans",
CurrentIntergral: "Current Points",
CurrentLocatedCity: "Current City",
CurrentLocation: "Current Location",
CurrentLocationReference: "Current Location (Reference Only)",
CurrentLxd: "Current Travel Beans",
CurrentlyBusiness: "Business travel inquiries only.",
CurrentlyOnlineInsuranceOnlySupportsTheFirstSegment: "Online insurance currently supports only the first leg.",
CurrentlyOnlyDomesticAirTickets: "Currently, only domestic flights are available.",
CurrentlyPrivate: "Currently, only personal travel searches are available.",
CurrentMobile: "Current Mobile Phone:",
CurrentPageDownload: "Download Current Page",
CurrentPassword: "Current Password",
CurrentPosition: "Current Location (Reference Only)",
CurrentSelectedLocation: "Selected Location",
CurrentVersion: "Current Version",
Custom: "Custom",
CustomerChoosesThePrice: "Customer Selects Price",
CustomerExperienceFirst: "Customer Experience First",
CustomerServiceSupport: "Customer Support",
CustomItems: "Custom Fields",
CustomizationsBound: "Custom Fields Linked",
CustomUseFld: "Custom Voucher Beans Usage",
CustomUseLxd: "Custom Travel Beans Usage",
DangerHelp: "If in danger, contact the police.",
Dark: "Dark Mode",
DataUpTo: "Data Updated To",
Date: "Date",
DateIsTheLocalDateOfDepartureCity: "The selected date is the current date in the departure city.",
DateOfBirth: "Date of Birth",
DateOptions: "Available Dates",
DeductionLxd: "Deduction",
DeductionRequired: "Deduction Amount",
Default: "Default",
Delete: "Delete",
Delete_1: "Remove",
DeleteFollow: "Unfollow",
DeleteFrequentFlyer: "Remove Frequent Flyer",
DeleteLocation: "Delete Location",
DeleteSuccessFailed: "Delete Failed",
DeleteSuccessful: "Deleted",
DeleteTrip: "Delete Trip",
DeliveryAddress: "Delivery Address",
DeliveryAfterSuccessfulBooking: "Reward after Booking",
DeliveryCity: "Delivery City",
DeliveryInfo: "Delivery Info",
DeliveryMethod: "Delivery Method",
DepartingColon: "Dep.:",
DepartingNow: "Depart Now",
Department: "Department",
DepartmentName: "Department Name",
DepartTime: "Departure Time",
Departure: "Departure",
Departure_1: "Pickup Location",
DepartureCity: "Departure City",
DepartureCityAddress: "Leaving from",
DepartureCityAndArrivalCityCannotBeSame: "Departure and arrival cities cannot be the same",
DepartureCityOptions: "Available Departure Cities",
DepartureDate: "Departure Date",
DepartureDateLocation: "Departure Date (Local Time)",
DepartureDateOptions: "Available Departure Dates",
DepartureEarliest: "Departure(Earliest)",
DepartureEarliest_1: "Departure(Earliest)",
DepartureLatest: "Departure(Latest)",
DepartureLatest_1: "Departure(Latest)",
DepartureStation: "Departure Station",
DepartureTerminal: "Departure Terminal",
DepartureTime: "Departure Time Slot",
DepartureTime_1: "Departure Station/Time",
DepartureTime_2: "Departure Time",
DepartureTime_3: "Departure Time Slot",
DepartureTimeCheckInDate: "Departure Time / Check-in Date",
DescribeYourNeeds: "Tell me what you need",
DesignateApprover: "Designated Approver",
DestinationOptions: "Available Destinations",
Detail: "Details",
Details: "Details",
Details_1: "View Details",
DetectedNewVersion: "New Version Available",
DidiDriverIsComing: "Driver is on the way",
DiDiTravel: "DiDi",
DifferentFromTheDepartingAirport: "Different from outbound departure airport",
DifferentFromTheOriginalScheduledArriveAirport: "Different from original arrival airport",
DifferentFromTheOriginalScheduledDepartureAirport: "Different from original departure airport",
DifferentFromTheOriginalScheduledDepartureAndrArriveAirport: "Different from original departure/arrival airports",
DiffPrice: "Fare Difference",
Dimension: "Analysis Dimensions",
Dimension_1: "Multi-dimensional Analysis",
Diner: "Guest",
DinerDetail: "Guest Details",
DinerInfomation: "Guest Information",
DinerName: "Guest Name",
Dingtalk: "DingTalk",
DingTalkByAccount: "DingTalk Account",
DingTalkByUser: "Link DingTalk Staff Account",
Direct: "Nonstop",
DirectFlightFirst: "Nonstop First",
DirectionsForUse: "Instructions",
DirectlyOpenAlipay: "Open Alipay",
Disagree: "Reject",
DiscountDistribution: "Discount Distribution",
DiscountInterval: "Discount Range",
DisplayTicketPrice: "Show Fares",
DistanceLowToHigh: "Straight-line distance (near to far)",
DistanceNearToFar: "Nearest First",
DocumentDetails: "Document Details",
DocumentInformationVerificationFailed: "Verification Failed",
DocumentSignatory: "Issuing Country/Region",
DomAverageDiscount: "Avg. Domestic Discount (Economy)",
DomesticFlights: "Domestic Flights",
DomesticFlights_1: "Domestic Flights (Excl. HK/MO/TW)",
DomesticFlightsApplication: "Domestic Flight Request",
DomesticFlightsOrderConfirmation: "Domestic Flight Confirmation",
DomesticHotel: "Domestic Hotels",
DomesticHotel_1: "Domestic Hotels (Incl. HK/MO/TW)",
DomesticHotelApplication: "Domestic Hotel Request",
DomesticHotelOrderConfirmation: "Domestic Hotel Confirmation",
DomesticHotelOrders: "Domestic Hotel Orders",
DomesticServicePhone: "Domestic Hotline",
DomesticTicketChange: "Domestic Flight Change",
DomesticTicketChangeApplication: "Domestic Flight Change Request",
DomesticTicketOrder: "Domestic Flight Order",
DomesticTicketRefundApplication: "Domestic Flight Refund Request",
DomFullFareTicketRate: "Domestic Full Fare Rate",
DoNotChange: "Cannot Change",
DoNotChangeBack: "No Refund or Change",
DoNotChooseForNow: "Skip for Now",
DoNotUse: "Do Not Use",
DoNotUseFld: "Do Not Use Voucher Beans",
DoNotUseLxd: "Do Not Use Travel Beans",
DoubleSIMDeviceTip: "This device has dual SIM cards. Please select the correct number to send SMS.",
Download: "Download",
DownloadAll: "Download All",
Downloaded: "Downloaded",
DownloadFailed: "Download Failed",
DownloadPolicy: "Download Insurance Policy",
DownloadSchedule: "Download Details",
DownloadTemplate: "Download Template",
DownloadTheQRcode: "Download QR Code",
DowntownCenter: "Downtown",
DoYouWantToLeaveHumanCustomerService: "Leave Live Chat?",
DoYouWantToSwitchToPerson: "Switch to personal account?",
DoYouWantToSwitchToUnit: "Switch to corporate account?",
DragMapToSetPoint: "Drag the map to select a location",
DrillMultipleChoice: "Diamond Level (Multiple)",
DriverArrival: "Driver Arrived",
DriverArrivedCancelConfirm: "The driver has arrived at the pickup point. Cancel the ride?",
DriverArriving: "Driver is on the way...",
DriverComingCancelConfirm: "The driver is on the way. Are you sure you want to cancel the ride?",
DriverPriorityContact: "Contact the Driver First",
DropDownToViewHistory: "Pull down to view message history",
DropOffCity: "Drop-off City",
Duration: "Trip Duration",
DutyParagraph: "Company Tax ID",
DwellTime: "Stay Duration",
Dysfunction: "Feature Issue",
EarlyThisMorning: "Early This Morning",
EarlytoLate: "Departure Time: Earliest to Latest",
EconomicHotel: "Budget Hotels",
EconomicHotel_1: "Economy",
EconomyClass: "Economy Class",
Edit: "Edit",
EditContact: "Edit Contact",
EditContactFailed: "Failed to edit contact",
EditCostCenter: "Edit Cost Center",
EditDepartment: "Edit Department",
EditFrequentContact: "Edit Frequent Contacts",
EditInvoiceHeader: "Edit Invoice Title",
EditRC: "Edit RC",
Effective: "Effective",
EffectiveDate: "ID Validity Period",
ElectronicInvoice: "E-Invoice",
Email: "Email",
EmailAddress: "Email Address",
EmailAddress_1: "Email",
EmailApproval: "Email Approval",
EmailCannotBeEmpty: "Email is required",
EmailChineseOrEnglishForFlight: "· Chinese/English confirmation email (Chinese/English flight confirmation PDF attached)",
EmailChineseOrEnglishForTrain: "· Chinese/English confirmation email (Chinese/English train ticket confirmation PDF attached)",
EmailFormatIsIncorrect: "Invalid email format",
EmergencyContact: "Emergency Contact",
EmergencyContactMobile: "Emergency Contact Phone",
EmergencyContactName: "Emergency Contact Name",
EmergencyContactNumber: "Emergency Contact Phone",
EmergencyHelp: "Emergency Help",
Emission: "Emissions (kg)",
EmployeeDetails: "Staff Details",
EmployeeInformation: "Staff Information",
EmployeeManagement: "Staff Management",
EmployeeNumber: "Staff Count",
EmployeesCanApply: "Staff can request to join the team via the link.",
EmployeesCcanScan: "Staff can scan the QR code to join the team.",
EmptyFileCannotBeUploaded: "Empty files cannot be uploaded. Please select another file.",
EnableFingerprintLogin: "Enable Fingerprint Login",
End: "End",
EndDate: "End Date",
EndorseTrain: "Change",
EnglishName: "English Name",
EnquiryOrderNumber: "Request ID",
EnterANewPassword: "New Password",
EnterflightNoMU5166: "Flight number (e.g., MU5166)",
EnteringKefu: "Connecting to a live agent",
EnterMembershipNumber: "Membership Card Number",
EnterNewMobile: "New Mobile Phone",
EnterPhoneNumber: "Please Enter Mobile Phone",
Enterprise: "Company",
EnterpriseCertification: "Company Verification",
EnterpriseCodeBind: "Link Corporate Code",
EnterpriseCodeDescription: "Corporate Code is a corporate payment capability based on Alipay.",
EnterpriseCodePay: "Corporate Code Payment",
EnterpriseCooperation: "Corporate Partnership",
EnterprisePaymentCompleteTicket: "Complete ticket purchase via Enterprise Payment",
EnterTheLastFourDigitsOfYourID: "Last 4 Digits of ID Number",
EnterVerificationCode: "Verification Code",
EnterVerificationCode_1: "Verification Code",
EnterVerificationCodeForThe12306: "12306 Verification Code",
EnterYourNewPasswordAgain: "Re-enter New Password",
EntryTimes: "Number of Entries",
EssentialDocuments: "Required Documents",
Estimate: "Estimated",
EstimateMeteredBilling: "Estimated (metered fare; actual fare applies)",
ETA: "Estimated Arrival",
Etc: "etc.",
EUR: "Euro",
EvaluateKefu: "Rate this service",
ExactlyLate: "On-time / Delayed",
ExceedingOrderAmount: "Exceeds Discount Limit",
Exchange: "Redeem",
Exchange_1: "Redeem Now",
ExchangeSerialNumber: "Redemption ID",
ExchangeSuccessful: "Redemption Successful",
ExcludingFullPriceAverageDiscount: "Excluding Full-Fare Average Discount",
ExclusiveBrandPrivileges: "Exclusive Brand Benefits",
ExecuteAction: "Action",
ExistingBusinessTravelAccount: "Existing Homsom Corporate Client",
ExistingStaff: "Existing Staff",
Exit: "Emergency Exit",
ExitWarning: "Logging out will unlink WeChat from this account, and you will no longer receive WeChat notifications for this account. Are you sure you want to sign out?",
ExpandMore: "Show more",
ExpectedTravelDate: "Expected Travel Date",
ExpectToAt: "Estimated",
Expired: "Expired",
ExportFormat: "Export Format",
ExportOrder: "Download Order Details",
Express: "Express",
ExpressDelivery: "Express Delivery",
Ext: "Ext.",
ExtendedInformation: "Additional Info",
Face: "Face Verification",
FaceGetCameraFailTips: "Camera access is unavailable. Check camera permissions. If the issue persists, copy the link and open it in another browser. If camera access is already allowed, tap Continue.",
FaceIDIsNotEnabled: "Face ID is not enabled on this device",
FaceIDIsOnlyValidForTheMachine: "Face ID is only valid on this device",
FaceIDLogin: "Face ID Login",
FacilitiesDetails: "Facilities/Details",
FacilityServices: "Facilities",
FailedToAccessTheCamera: "Camera access failed",
FailedToChangePassword: "Failed to change password",
FailedToGetPleaseTryAgainLater: "Failed to retrieve. Please try again later.",
FailedToResetPassword: "Password reset failed",
FalseAlarmAccountability: "False emergency reports will be investigated according to law.",
FalseAlarmAccountabilityDesc_1: "One-tap emergency assistance connects you to platform customer service. In emergencies involving personal or property safety, call 110 directly.",
FalseAlarmAccountabilityDesc_2: "False emergency reports may result in detention for 5 to 10 days.",
FalseReport: "False emergency reports may result in legal liability.",
Favorites: "Favorites",
FeaturedIntroduction: "Feature Overview",
Feedback: "Feedback",
Feishu: "Feishu",
FeishuByAccount: "Feishu Account",
FeishuByUser: "Link Feishu Staff",
File: "File",
FileDownloadFailed: "Failed to retrieve file",
FillInAccordingToTheActualNumber: "Enter the actual number of travelers",
FillInAccurateAndCompleteUnitInformation: "Please provide accurate and complete company information so we can serve you better.",
FillingGuide: "Guide",
FillInTheReason: "Enter reason",
FillInYourBoundEmailAddress: "Enter your linked email address",
FillTaxNumberIfAvailable: "Enter your tax ID if available.",
Filter: "Filter Criteria",
Filter_1: "Advanced Filters",
Filters: "Filter",
FindANewQueryQuote: "Find New Quote",
FingerprintDoItAgain: "Verification failed. Please try again.",
FingerprintTouch: "Touch the fingerprint sensor lightly",
FingerprintVerification: "Fingerprint Verification",
FingerprintVerificationTooManyTimes: "Too many fingerprint verification attempts. Please try again later.",
Finish: "Done",
Finished: "Completed",
FirstBusinessClass: "First/Business Class",
FirstClass: "First Class",
FirstClassSeat: "First Class Seat",
FirstNameFormatIsIncorrect: "Invalid English name format",
FirstStep: "Step 1",
FixedPrice: "Fixed Price",
Fld: "Voucher Beans",
FldDetails: "Voucher Beans Details",
FldRules: "Voucher Beans Rules",
FldUsageRules: "Voucher Beans Usage Rules",
Flight: "Flights",
FlightBookPermission: "Flight Booking Permission",
FlightCancellationDelayForMoreThan: "Flight cancellations or delays of 30 minutes or more are subject to airline approval.",
FlightConfirmationWarn: "For visa applications and immigration checks, you can print the confirmation and carry it with you during your trip.",
FlightDate: "Flight Date",
FlightDeparturesAreLocalTime: "All departure and arrival times are local time.",
FlightDetails: "Flight Details",
FlightDynamicsAreForReferenceOnly: "Flight status is for reference only. Please refer to the airline's official updates.",
FlightInformation: "Flight Status",
FlightInformationDesc: "Trip reminders, such as flight changes",
FlightInfoSync: "Flight status will be shared with the driver for on-time pickup and drop-off.",
FlightNo: "Flight No.",
FlightNumber: "By Flight No.",
FlightNumberHotelTrainNumber: "Flight No./Hotel/Train No.",
FlightPreference: "Flight Preferences",
FlightPricesChangeFrequently: "Airfares change frequently. Please complete payment as soon as possible to avoid delays.",
FlightRank: "Flight Standard",
FlightRefundOrderConfirm: "Flight Refund Order Confirmation",
FlightRefundTips: "Note: Checked-in passengers must cancel check-in before changing or refunding tickets. Once a refund is submitted, the seat will be canceled immediately. Please check all details carefully.",
FlightRefundTrip: "Refund Trips",
FlightRescheduleOrderConfirm: "Flight Change Request Confirmation",
FlightReschedulingOrRefundTips: "Note: Checked-in passengers must cancel check-in before changing or refunding tickets.",
FlightSeatInfoArrow: "Seat Selection Info >",
FlightsRefunds: "Domestic Flight Refunds",
FlightTicket: "Flights",
FlightTicketInquiry: "Flight Quote",
FlightTicketIssuedGetReceiptByEmail: "Ticket issued. You can get the reimbursement voucher by email.",
FlightTicketLatitude: "Flight Dimension",
FlightType: "Flight Type",
FloatingOptionalDate: "Flexible Available Dates",
Floor_1: "Floor",
FollowFromEmployee: "Follow Staff",
FollowTheSystem: "Follow System",
Foods: "Meals",
FoodTotalPrice: "Total Product Price",
ForDomesticTicketsPleaseReturnToTheHomePageAndSelectDomesticTickets: "To search for domestic flights, return to the home page and select Domestic Flights.",
ForgetPassword: "Forgot Password",
ForgetPassword_1: "Forgot Password?",
FormatIsIncorrect: "Invalid format",
Founder: "Creator",
Free: "Express Shipping | Free Shipping",
FreeBoardband: "Free WI-FI",
FreeParking: "Free Parking",
FreePickUpService: "Free Airport Pickup",
FreeWiFi: "Free Wi-Fi",
FrequentContacts: "Frequent Contacts",
FrequentContactsManagement: "Contact Management",
FrequentTraveler: "Frequent Traveler",
FrequentTravelerCardInformation: "Frequent Flyer Card",
FrequentTravelerManagement: "Frequent Traveler Management",
FriendsareWaiting: "Your friends are waiting for you on Homsom — join us with this exclusive link!",
Fuel: "Fuel",
FuelFee: "Fuel Surcharge",
FullPrice: "Full Fare",
FullyBooked: "Sold Out",
FullyCallingTheVehicle: "Requesting vehicle",
FunctionIntro: "Feature Overview",
GBP: "GBP",
Gender: "Gender",
GeneralAmenities: "Amenities",
GeneralCarUsage: "Taxi Overview",
GeneralConditionsOfTransportation: "Conditions of Carriage",
GeneralTrainTicket: "Train Tickets Overview",
Generated: "Generated",
GenerateTravelReports: "Generate Report",
GenerationFailed: "Generation Failed",
GenerationSuccessful: "Generated Successfully",
GetDidiJumpUrlFailed: "Failed to retrieve the Didi redirect link",
GetInTheCar: "Board",
GetSMS: "Get Code",
GettingBoardingLocation: "Retrieving pickup location",
GiveLXDAfterBookSuccess: "Get Travel Beans after successful booking",
GivenNames: "Given Name (Pinyin)",
GivenNamesEg: "e.g. MEIMEI",
GivenNamesHint: "For example, Wang Dawei should be entered as DAWEI",
GoAlipayCorpPay: "Go to Alipay Corporate Payment",
GoAndReturn: "Dep./Ret.",
GoApprovals: "Submit Request",
GoBook: "Book Now",
GoEnquiry: "Request Quote",
GoFlight: "Departure Flight",
Going: "Depart",
GoingDate: "Departure Date",
GoingFilter: "Departure Filter",
GoingTo: "Upcoming",
GoLogin: "Login",
GoToAlipayOpenEnterpriseCode: "Activate Corporate Code in Alipay",
GoToBind: "Link Now",
GoToChange: "Change",
GoToDidiHome: "Didi Home",
GoToDownload: "Download",
GoToHotel: "Hotels",
GoToPay: "Pay Now",
GoToQuery: "Go to Search",
GoToRefund: "Refund",
GoToSettings: "Go to Settings",
GoToShare: "Share",
GoToVerify: "Verify",
GoToView: "View",
Greeting: "Hello, nice to meet you!",
Guarantee: "Guarantee",
Guarantee_1: "Guarantee Required",
GuessYouWantToFindIt: "You Might Also Ask",
Guests: "Sleeps",
Gym: "Gym",
Handled: "Done",
HasProblem: "Payment Issues",
HasQuitHumanCustomerService: "Live chat ended",
HaveAgreement: "Negotiated Rates",
HaveQuestions: "Questions? Click below to contact us.",
HaveRefund: "Refunds",
HaveRescheduled: "Changes",
HelpCenter: "Help Center",
HengshunTravelAPP: "Homsom Business Travel App",
HightoLow: "Highest Price",
History: "History",
HistoryOrder: "History Orders",
HistoryOrHot: "History/Popular",
HistoryOrLocation: "Current/History",
HistoryRecord: "History (Last 1 Year)",
HKD: "HKD",
HoldToSpeak: "Press and speak",
HoldToTalk: "Press and speak",
Home: "Home",
HOMSOM: "Homsom",
Homsom: "My Homsom",
HomsomEnterpriseCooperation: "Homsom Corporate Partnership",
HomsomEnterpriseCooperationDesc: "If your company already works with Homsom, contact your account manager for login access. Please do not register again.",
HomsomFWXY: "Terms of Service",
HomsomGuarantee: "Homsom Guarantee",
HomsomLoginPrivacyInfo: "I have read and agree to the Terms of Service and Privacy Policy",
HomsomLoginPrivacyTitle: "Review and accept the following terms",
HomsomLoginPrivacyValue: "Please read and agree to the Terms of Service and Privacy Policy before logging in.",
HomsomLxd: "Homsom Travel Beans",
HomsomPrivacyInfo: "Terms of Service and Privacy Policy",
HOMSOMScanningCodeLoginConfirmation: "Homsom QR Login Confirmation",
HomsomServiceFee: "Homsom Service Fee",
HomsomServiceFeeByChange: "Homsom Change Fee",
HomsomServiceFeeByIssue: "Homsom Ticketing Fee",
HomsomSuccessDesc: "Homsom Business Travel has completed this booking for you.",
HomsomTools: "Tools",
HomsomUpdateToExperience: "Homsom Business Travel has been updated again—come check it out now!",
HomsomYSZC: "Privacy Policy",
Hot: "Popular",
Hot_1: "Popular Redemptions",
HotChina: "Popular in China",
Hotel: "Hotels",
HotelAddress: "Hotel Address",
HotelBedNeeds: "Bed Preferences",
HotelBookPermission: "Hotel Booking Permissions",
HotelBookWarn: "Please read the 'Homsom Hotel Booking Terms', 'Personal Information Authorization Statement', and 'Supplier Booking Terms' before submitting your order.",
HotelBookWarn_1: "'Homsom Hotel Booking Terms', 'Personal Information Authorization Statement', 'Supplier Booking Terms'",
HotelChargeback: "Hotel Refund",
HotelCheckInInfo: "Check-in Info",
HotelConfirmEmailChineseOrEnglish: "· Chinese/English confirmation email (Chinese/English check-in voucher PDF attachment)",
HotelConfirmNumber: "Confirmation No.",
HotelConfirmSMSChineseOrEnglish: "· Chinese/English confirmation SMS",
HotelConsumptionInEachCity: "Hotel Spending by City",
HotelContactMobile: "Contact Mobile",
HotelContactMobilePlaceholder: "For receiving notifications",
HotelDetails: "Hotel Details",
HotelDimension: "Hotel Dimension",
HotelEnglishFirstNameHint: "First Name (e.g. San)",
HotelEnglishFirstNameRequired: "Please fill in first name (Pinyin or English)",
HotelEnglishLastNameHint: "Last Name (e.g. Zhang)",
HotelEnglishLastNameRequired: "Please fill in last name (Pinyin or English)",
HotelFeature: "Hotel Highlights",
HotelGeneral: "Hotel Overview",
HotelGroupMembership: "Hotel Group",
HotelGroupMembershipCard: "Group Membership Card",
HotelGroupMembershipCard_1: "Hotel Group Loyalty Card",
HotelGroupMembershipCardBind: "Link Membership",
HotelGroupMembershipCardDetails: "Membership Card Details",
HotelGroupMembershipCardInfo: "Membership Card Info",
HotelGuestName: "Guest Name",
HotelGuestNameInvalid: "Invalid guest name format",
HotelGuestNamePlaceholder: "Please fill in guest name",
HotelIntroduction: "Hotel Overview",
HotelInvoiceExplain: "Note: Room invoices are issued by the hotel; request one at the front desk.",
HotelIsSendRefundEmail: "Send Refund Email",
HotelIsSendRefundSms: "Send Refund SMS",
HotelLatestRoomPrice: "Latest hotel rates fetched",
HotelMemberCardDesc: "Exclusive membership rewards",
HotelMoreGuests: "More Guests",
HotelName: "Hotel Name",
HotelNight: "Total Room Nights",
HotelOtherNeeds: "Other Requests",
HotelPayInStore: "Pay at Hotel",
HotelPriorityContact: "Hotel Priority Contact",
HotelPromptIsMorning: "Check-in before 6:00 AM today.",
HotelQuickConvertPinyin: "Convert to Pinyin",
HotelQuickSelectGuest: "Select Guest",
HotelRank: "Hotel Standard",
HotelRating: "Hotel Rating",
HotelRC: "Hotel RC",
HotelReasonCodeDistribution: "Hotel Reason Code Distribution",
HotelRefundGuestTitle: "Refunded Guest",
HotelRefundInformation: "Refund Details",
HotelReservationAuthority: "Domestic Hotel Standard",
HotelRestaurant: "Hotel Restaurants",
HotelRoomNumber: "Number of Rooms",
HotelRoomRemarkInputTip: "Please enter other requests and the hotel will try to accommodate them.",
Hotels: "Hotels",
HotelSelectChargebackGuest: "Select Refund Guest",
HotelService: "Hotel Services",
HotelServicePreferences: "Service Preferences",
HotelServicePreferences_1: "Service Preferences",
HotelSpecialNeeds: "Special Requests",
HotelSpecialNeedsEditHint: "Enter your requests and the hotel will try to accommodate them.",
HotelSpecialNeedsExplain: "Requests will be forwarded to the hotel but are not guaranteed. Please contact the hotel directly for special requests.",
HotelTotalAmount: "Total Hotel Cost",
HowSoonWillYouNeedTheCarAfterLanding: "Pickup Time After Arrival",
HowToUseTip: "Not sure how to use it?",
HsTravelerExplainContext: "The traveler information you provide in Homsom will be used for booking flights, train tickets, and other real-name services. Please ensure the information is accurate and valid. Homsom protects your information through encryption and only shares it with relevant third parties when necessary for transactions.",
HsTravelerExplainTitle: "Read and Agree",
IAm: "I'm",
ID: "ID No.",
IDCard: "ID Card No.",
IDCardFormatIsIncorrect: "Invalid ID card number.",
IdNameMatchTip: "Must match the name on the ID",
IDNoVerify: "ID Verification",
IDNumber: "ID No.",
IDType: "ID Type",
IfTheApproverIsInconsistent: "Submit separate orders for different approvers.",
IfTheRemainingSeats: "If your preferred seat is unavailable, a seat will be assigned automatically.",
IfTheTicketHasBeenIssuedTheLossMustBeBorneByTheOwner: "2. Change and refund fees after ticket issuance are at your own expense.",
IfYouCheckThisOption: "Selecting this option marks upcoming trips as personal travel.",
IfYouHaveAnyQuestions: "For assistance, call Homsom support: 4006-123-123",
IfYouHaveAnyQuestionsPleaseContactYourBusinessConsultant: "Please contact your business consultant if you have any questions.",
IfYouNeedToNarrowTheScopePleaseEnterMoreConditions: "Add more conditions to narrow results.",
IGotIt: "Got It",
IHaveReadAndAgree: "I Have Read and Agree",
ImageAndFileCannotSelectTogether: "Images and files cannot be selected together.",
Import: "Import",
Import_1: "Import",
ImportBusiness: "Import (Business)",
ImportFailed: "Import failed",
ImportFromFrequentTraveler: "Import from Staff",
ImportSuccess: "Import successful",
IncludingHongKongMacauAndTaiwan: "Incl. HK, Macau & Taiwan",
Income: "Revenue",
IncomeExpenditure: "Income & Expense Details",
InconsistentPasswordEnteredTwice: "Passwords do not match.",
IncorrectFormatOfContactMobileNumber: "Invalid contact mobile number.",
Indexs: "A-Z Index",
IndividualOrNonEnterprise: "Individual / Non-Corporate",
InformationDescription: "Information",
InformationIsIncomplete: "Incomplete information",
InformationVerification: "Verify Information",
Infrastructure: "Infrastructure",
Initiated: "Initiated",
InitiativeEnthusiasmEfficientMeticulousSpecialty: "More proactive, passionate, efficient, attentive, and professional",
InnovativeService: "Innovative Service",
InPersonRequired: "Presence Required",
InputBookingPassword: "Please enter Booking Password",
InputBookingPwdTip: "Payment will be deducted from corporate account, please enter booking password",
InputConfirmPassword: "Please enter Confirm Password",
InputHint: "Tell me your needs and I will try my best to help you~",
InputInformation: "Enter Information",
InputQuestionHint: "Ask a question...",
InquiryInformationIsInvalid: "Query expired",
Install: "Install Now",
Instructions: "Notes",
InsufficientRemainingTicketsChooseOtherFlight: "Insufficient seats. Please select another cabin.",
InsuranceNotice: "Insurance Notice",
Insurers: "Insurance",
Integral: "Points",
Integral_1: "Product Points",
IntegralByHomsom: "Homsom Points",
IntegralMall: "Points Redemption",
IntercityCarHailing: "Intercity Ride",
IntergralDescription: "Points Details",
IntergralRules: "Points Rules",
InternalProcurement: "Internal Procurement",
International: "Overseas",
InternationalHotel_1: "Overseas Hotels (Excl. HK/MO/TW)",
InternationalHotelOrderConfirmation: "Overseas Hotel Confirmation",
InternationalHotelOrders: "Overseas Hotel Orders",
InternationalRegion: "International / HK/MO/TW",
InternationalRegion_1: "Intl Flights · HK/MO/TW",
Internet: "Wi-Fi",
InTheLocation: "Locating",
InTheTicket: "Issuing",
Intl_1: "Intl",
IntlDestination: "Intl Destinations",
IntlFlightEnquiry: "Intl Flight Request",
IntlFlightEnquiryService: "Intl Flight Quote",
IntlFlightEnquiryServiceDesc: "Manual quotes, easier booking",
IntlFlightOrder: "Intl Flight Order",
IntlFlightRank: "Intl Flight Standard",
IntlFlights: "Intl Flights",
IntlFlights_1: "Intl Flights (Incl. HK/MO/TW)",
IntlFlightsChange: "Intl Flight Change",
IntlFlightsOrderConfirmation: "Intl Flight Confirmation",
IntlFlightsRefund: "Intl Flight Refund",
IntlHotel: "Overseas Hotels",
IntlHotelReservationAuthority: "Overseas Hotel Standard",
InTrainTransfer: "Train Transfer",
InTravel: "Traveling",
Invalid: "Invalid",
InvitationOtherType: "Other Invite Methods",
InvitationStaff: "Invite Staff",
Invitee: "Inviter",
InviteEmployeesToJoin: "Invite staff using any method below. After approval, staff will receive an SMS notification.",
Invoice: "Invoice",
InvoiceAmount: "Invoice Amount",
InvoiceAmount_1: "Invoice Amount",
InvoiceCheckGuide: "View now or continue invoicing in Pending Invoices.",
InvoiceContent: "Invoice Content",
InvoiceDetais: "Invoice Details",
InvoiceFilling: "Invoice Info",
InvoiceFinished: "Invoiced",
InvoiceHeader: "Invoice Title",
InvoiceHeaderName: "Invoice Title",
InvoiceHeaderType: "Header Type",
InvoiceInformation: "Invoice Info",
InvoiceInst: "Invoice Instructions",
InvoiceIssuingMustRead: "Invoice Notice",
InvoiceOperating: "Issuing",
InvoiceParagraph: "Invoice Tax ID",
InvoicePreview: "Invoice Preview",
InvoiceRemarks: "Invoice Remarks",
InvoiceTitleCannotBeAllNumbers: "Invoice title cannot be all numbers",
InvoiceTitleCannotEdit: "Saved invoice titles cannot be edited. Please delete and add again.",
InvoiceTitleFillReminder: "Please verify invoice details carefully. Incorrect information may cause invoice issuance, download, or reimbursement failure.",
InvoiceTitleManagement: "Invoice Title Management",
InvoiceType: "Invoice Type",
InvoicingStatus: "Issuance Status",
InvoluntaryRefund: "Involuntary Refund",
InvoluntaryRefundDesc: "Involuntary Refund (Flight cancellation/delay over 30 mins, subject to airline approval)",
InvoluntaryRefundExplain: "Involuntary Refund Policy",
InvoluntaryReschedule: "Involuntary Change",
InvoluntaryRescheduleDesc: "Involuntary Change (Flight cancellation/delay over 30 mins, subject to airline approval)",
InvoluntaryRescheduleExplain: "Involuntary Change Policy",
IsLoggedIn: "Logged in",
IsSendReceiveEmail: "Booking Email",
IsSendReceiveSms: "Booking SMS",
IssuedAmount: "Issued Amount",
IssueElectronicInvoice: "Issue E-Invoice",
IssueInvoice: "Issue Invoice",
Issuing: "Issuing",
JobDescription: "Standard Description",
JoinedEnterpriseGetResult: "Joined enterprise, retrieving authorization results",
JPY: "JPY",
JuHeYongCheNotIncludeDiDiTravel: "Aggregated ride-hailing excludes DiDi",
JumpToDidi: "View in DiDi",
JustLookAtTheHighSpeedTrain: "High-speed Rail Only",
JustTime: "Just now",
KeyBusinessTripInfo: "Additional ride information required by company policy",
KeyMoreCarTypes: "More Car Types",
KeyMoreSelectionFaster: "More selections, faster pickup",
KeySwipeUpMoreCars: "Swipe up for more car types",
KeyTaxiMeterPricing: "Taxi fares are metered and subject to actual charges",
Keywords: "Keywords",
KeywordSearch: "Keyword Search (Hotel Name)",
KeywordSearch_1: "Location / Brand / Hotel Name",
KPIAnalysis: "Air Ticket KPI Analysis",
KRW: "KRW",
LackOfIntegral: "Insufficient Points",
Landing: "Arrival",
Language: "Languages",
LanguageBeingSet: "Setting language...",
LanguageCH: "Chinese",
LanguageDefault: "Default Language",
LanguageEN: "English",
LanguageSetting: "Language Settings",
LastNameFormatIsIncorrect: "Invalid surname format",
LatestArrivalDate: "Latest Credit Date",
LateToEarly: "Departure Time: Evening–Morning",
Latitude: "Multi-Dimensional Analysis",
LearnAbout: "Reminder",
LearnMore: "Learn More",
LessThan10People: "Up to 10 People",
LetYourFriendsAlsoDownloadHengshunTravelAPP: "Invite your friends to download the Homsom app",
Light: "Light Mode",
LinkYourCellphone: "Link Phone",
List: "List",
Loading: "Loading...",
Loading_1: "Refreshing...",
LoadMoreTransit: "Load More Transfer Trains",
LocacleHotHotelRecommend: "Popular Local Hotels",
LocalTax: "Local Taxes",
LocalTime: "Local Time",
LocalTimeOfTheDepartureCity: "Departure City Local Time",
Location: "Current Location",
Location_1: "Location",
Location_2: "Distance",
LocationFailed: "Failed to Get Current Location",
LocationNotTurnOn: "Location Disabled",
LocationOfTheUnit: "Company Location",
LocationPermissionClosed: "Location permission disabled. Enable it in Settings.",
LocationPermissionNotEnabled: "Location Permission Disabled",
LocationPermissionRequest: "Location Permission Request",
LocationPermissionRetryMessage: "Location permission is required. Open it again?",
LocationPermissionSettingsMessage: "Location permission is disabled. Please enable it in system settings.",
LocationPermissionUsageMessage: "Used to get your current location and provide location‑based services.",
LocationPermissionUsageTitle: "Location Permission Usage",
Login: "Log In",
Login12306: "Log In to 12306",
Login12306Account: "Log In to 12306 Account",
Login12306AccountDesc_1: "Real-name verification required for ticket purchase",
Login12306AccountDesc_2: "Use your 12306 account for booking, refunds, and changes",
Login12306AccountEnjoyExtremeReversionMemberPoints: "Log in to enjoy flexible refunds, changes, and member points",
Login12306FaceToBeCompleted: "Face Verification Required",
Login_1: "Log In",
LoginByAccountPassword: "Account Login",
LoginByVerificationCode: "Verification Code Login",
LoginByVerificationCodeEmail: "Email Code Login",
LoginByVerificationCodeSMS: "SMS Code Login",
LoginConfirm: "Confirm Login",
LoginExpired: "Session Expired. Please Log In Again.",
LoginName: "Account",
LoginOut: "Sign Out",
LoginSuccessful: "Logged In Successfully",
LoginSuccessful12306: "Logged In to 12306 Successfully",
LoginTo12306ToImproveTheSuccessRateOfTicketIssuance: "Log in to 12306 for higher ticketing success",
LogisticsCompany: "Logistics Company",
Logout: "Sign Out",
LongPressSaveTheQRcode: "Long Press to Save QR Code",
LookAtThePriceExcludingTax: "Price ex. tax",
LookCertificate: "View Certificate",
LookChargebackOrder: "View Refund",
LooOriginOrder: "View Original Order",
Loss: "Loss",
LossAnalysis: "Loss Analysis",
LossPercentage: "Loss Ratio",
LowCarbonHomsomPlantingHomsomForestTogether: "Low-Carbon Homsom, Grow the Homsom Forest Together",
LowestPrice: "Lowest Price",
LowestPrice_1: "Lowest Price",
LowestPriceDetails: "Lowest Price Details",
LowestTicketPrice: "Lowest Airfare",
LowPriceFlightRecommendation: "Recommended Low-Cost Flights",
LowtoHigh: "Lowest Price",
LowVersionTip: "Your current App version is outdated, please update to the latest version",
LuggageStorage: "Luggage Storage",
LuxuryHotel: "Luxury Hotels",
LuxuryHotel_1: "Luxury",
Lxd: "Travel Beans",
LxdDetails: "Travel Beans Details",
LxdReward: "Travel Beans Rewards",
LxdRewardCompleteTheOrderToObtain: "Earn after order completion",
LxdRules: "Travel Beans Rules",
LxdUsageRules: "Travel Beans Usage Rules",
MailSent: "Email sent",
MainFlight: "Main Flight",
MainRoomer: "Primary Guest",
MainRoomerRequired: "Primary Guest (Required)",
MakeInvoice: "Issue Invoice",
MakeSureToClearCache: "Clear Cache?",
MakeSureToFingerprintLoginClose: "Disable fingerprint login?",
MakeSureToLeaveYourCurrentAccount: "Are you sure you want to sign out?",
Manage: "Manage",
Manager: "Handler",
ManualApproval: "Manual Approval",
ManualChange: "Manual Change",
ManuallyImport: "Manual Import",
ManuallyPassed: "Manually Approved",
ManualModification: "Manual Edit",
ManualRefund: "Manual Refund",
Map: "Map",
MapNavigation: "Map Navigation",
MapPointSelection: "Map Selection",
MapSelection: "Map Selection",
MapSurroundings: "Map/Nearby",
MarkAllMessagesAsRead: "Mark all messages as read?",
MatchingTheBestDriverForYou: "Matching the best driver for you...",
MaximumFaceValue: "Maximum Ticket Price",
MayBeAt: "May be available at",
Meals: "Meals Included",
MealsGoods: "Dining",
MealsOrder: "Meal Order",
MealsOrderConfirm: "Meal Order Confirmation",
MealsRank: "Meal Standard",
MealsRemarks: "Meal Notes",
MeetingRoom: "Meeting Room",
MembershipCardNumber: "Card No.",
MembershipNumber: "Card No.:",
MergeIssueReimbursableAmount: "Combined Invoiceable Reimbursable Amount",
Message: "Messages",
MessageCenter: "Message Center",
MessageFailedToSend: "Failed to send message. Please try again.",
MessageSendSuccessfully: "Message sent successfully",
MethodOne: "Option 1",
MethodThree: "Option 3",
MethodTwo: "Option 2",
MicrophoneIsRequiredForCurrentService: "Microphone access required. Enable it in Settings.",
Mileage: "Mileage",
MiniProgramDoesNotSupportDiDiPleaseUseHomsomApp: "DiDi ride-hailing is not supported in the Mini Program. To use DiDi, please download and use the Homsom app.",
Minute: "min",
MissedSavingAnalysis: "Missed Lowest Fare Loss",
MixedPayment: "Out-of-Policy Payment",
MixedPaymentDesc: "Pay the excess amount yourself for premium hotels.",
MixedPaymentOpen: "Out-of-Policy Payment Enabled",
MixedPaymentOpenDesc: "Pay the difference to upgrade to a better room",
MixedPaymentSelfPayment: "Excess Amount Self-paid",
MnlyOneMembershipCardCanBeAddedToTheSameHotel: "Only one membership card can be added per hotel.",
MobileCode: "Country/Region Code",
MobileInvitationCode: "Mobile Invitation Code",
MobileInvitationCodeShare: "Share the QR code image in your company group chat. Colleagues can scan it to submit requests.",
MobileLinked: "Phone linked",
MobilePhoneNumberVerification: "Phone Verification",
MobileUnlinked: "Phone not linked",
ModifiedSuccess: "Updated successfully",
ModifiedSuccessfully: "Updated successfully! New mobile phone:",
Modify: "Edit",
ModifyTheBoundPhone: "Change Linked Phone",
Moments: "Moments",
MonthApr: "Apr",
MonthAug: "Aug",
MonthDeb: "Feb",
MonthDec: "Dec",
MonthJan: "Jan",
MonthJul: "Jul",
MonthJun: "Jun",
Monthly: "Monthly",
MonthlyExpense: "Monthly Expenses",
MonthlyKPI: "Monthly KPI",
MonthlySummary: "Monthly Summary",
MonthMar: "Mar",
MonthMay: "May",
MonthNov: "Nov",
MonthOct: "Oct",
MonthOnMonth: "MoM",
MonthSep: "Sep",
More_1: "More",
More_2: "See more",
More_3: "View more",
MoreCabinsNoResult: "No more cabins available",
MoreConsultation: "More Support",
MoreDate: "More Dates",
MoreDateB: "More Dates",
MoreDiner: "More Diners",
MoreFilterCriteria: "More Filters",
MorePassengerFlight: "More Travelers",
MorePassengerRoomer: "More Guests",
MorePassengerVehicle: "More Passengers",
MorePrice: "More Prices",
MoreSorting: "More Sorts",
MoreThan100People: "100+ People",
MoreThanThePurchaseLimitCanNotBuy: "Purchase limit exceeded",
MoreTraveler: "More Travelers",
Morning: "Early Morning",
MorningCall: "Wake-up Call",
MultipleAccountsHaveBeenBound: "This mobile phone is linked to multiple accounts. Please try another login method.",
MultipleChoice: "Multi-Select",
MultipleChoiceSuccessRate: "Multiple selections improve success rate",
MultiTierReschedulingNotSupported: "Multiple trip changes are not supported",
MustBeAccompaniedByAnAdultOnBoard: "Children/infants must travel with an adult",
MyAdvancePayment: "My Prepayments",
MyApplyTravel: "My Trip Requests",
MyApprovals: "Pending Approvals",
MyBalance: "My Balance",
MyCollection: "My Favorites",
MyCustomerService: "Support",
MyFld: "My Voucher Beans",
MyInitiations: "My Requests",
MyIntergral: "My Points",
MyLxd: "My Travel Beans",
MyTrip: "My Trips",
Name: "Name",
NameFillingInstructions: "Name Entry Instructions",
Nation: "Country/Region",
NationalityOfThePerson: "Guest Country/Region",
NationalServicePhone: "National Hotline",
NavigateToHotel: "Navigate to Hotel",
Near: "Nearby",
NearExpiration: "Expiring Soon",
NearlyOneMonthApply: "Requests in Last 30 Days",
NearlyOneMonthOrder: "Orders in Last 30 Days",
NearlyOneYear: "Last 12 Months",
NearlyOneYearOrder: "Orders in Last 12 Months",
NetList: "Online Booking",
NetTransactionPrice: "Net Price",
Network: "Network",
NetworkRequestConnectionFailed: "Network connection failed",
NetworkRequestFailed: "Network request failed",
New: "Add",
New_1: "Add",
NewCertificate: "Add ID",
NewContactSuccessFailed: "Failed to add contact",
NewContactSuccessFul: "Contact added successfully",
NewDepartment: "Add Department",
NewDialogAlready: "You are already in a new conversation.",
NewDiner: "Add Diner",
NewFlightDate: "New Flight Date",
NewFrequentTravelCard: "Add Frequent Flyer Card",
NewFrequentTravelCard_1: "Add Frequent Flyer Card",
NewHotelGroupMembershipCard: "Add Hotel Membership Card",
NewMobile: "New Mobile Phone",
NewPassenger: "Add Passenger",
NewPassengerFlight: "Add Passenger",
NewPassengerVehicle: "Add Passenger",
NewRC: "Add RC",
NewRoomer: "Add Guest",
NewTraveler: "Add Traveler",
NewVersion: "Use New Version",
NewVersionFound: "New version available",
NextStep: "Next",
NextStep_1: "Next",
NickName: "Nickname",
NoApply: "No requests",
NoApprovalRequired: "No approval required",
NoAvailableApply: "No matching requests found",
NoAvailableCabin: "No cabins available",
NoAvailableFlight: "No flights available",
NoAvailableFlightDesc: "No flights found matching your criteria. Please adjust your filters.",
NoAvailableHotel: "No hotels available",
NoAvailableHotelTip: "No hotels found matching your criteria. Please adjust your filters.",
NoAvailableOrder: "No matching orders found",
NoAvailableTrain: "No trains available",
NoAvailableTrainTip: "No trains found matching your criteria. Please adjust your filters.",
NoAvailableVouchersForUse: "No coupons available",
NoBindPhoneTip: "You haven't linked your Mobile Phone, go to Settings to link your phone",
NoBreakfast: "No breakfast",
NoChangeablePassengers: "No passengers eligible for changes",
NoChildUnderDepartmentsAtPresent: "No sub-departments available",
NoCollection: "No favorites",
NoData: "No results",
NoData_1: "No data",
NoDataBySearch: "No results found",
NoDataContent: "No content",
NoDataTravelStandard: "No travel policy info",
NoEnterpriseCodePayOrder: "Failed to obtain Corporate Code payment reference number",
NoIncludedChangeFeeTag: "(Change fees not included)",
NoItinerary: "No trips",
NoMeal: "No meals",
NoMore: "No more data",
NoMoreCredential: "No more IDs",
NonBookable: "Unavailable",
NoNet: "Network unavailable",
NoNewNotice: "No new notifications",
NoNews: "No messages",
NonStaff: "External Personnel",
NonStaffDetail: "External Personnel Details",
NonStaffManagement: "External Personnel Management",
Noon: "Noon",
NoOrder: "No orders",
NoOrderEnquiry: "No requests",
NoPermission: "No Permission",
NoPermissions: "No permissions",
NoPermissionToAccess: "Access denied",
NoPlatformAvailablePleaseContactYourTravelConsultant: "No available platforms. Please contact your travel consultant.",
NoRecordDevice: "No recording device available",
NoRemainingTickets: "Sold out",
NoReschedulingReeIsIncluded: "Excludes change fees",
NoReservationOrders: "No bookings",
NoResult: "No results",
NormalSeat: "Business Class",
NoStay: "Not checked in",
NotAuthorizedForNow: "Not Now",
NotBook: "Unavailable",
NotBooking_1: "Unavailable",
NotCertificateInfo: "No ID details",
NotCompletedTheIdentityVerificationFor12306: "Not completed 12306 identity verification?",
NotCompletedTheIdentityVerificationFor12306_1: "Your 12306 account requires verification. Please complete it.",
NotCompletedTheVerificationInOrder: "Passengers require identity verification",
NotesOnRefundAndChangeOfVisa: "Changes & Refunds Policy",
Nothing: "None",
Notice: "Notifications",
NoticeCanceled: "Cancellation Notice",
NoTicket: "No tickets",
NotInitiated: "Not started",
NotNecessaryChoose: "Optional",
NotNecessaryFill: "Optional",
NotNecessaryFillPleaseFillOrChoose: "Please enter or select",
NotNeedDepartPassenger: "No departing passengers",
NoTravelCard: "No frequent flyer program",
NoTravelStandard: "No travel standards",
NotRefundable: "Non-refundable",
NoTrip: "No itineraries found",
NotSelectable: "Unavailable",
NotSendEmptyInfo: "Cannot send empty messages",
NotSet: "Not Set",
NotSupportOnlineInvoice: "Online invoicing is not supported",
NotUsed: "Not used",
NoVisaProductsAvailable: "No visa products available",
Now: "Now",
Number: "Passengers",
Number_1: "Quantity",
NumberOfAdult: "Adults",
NumberOfChild: "Children",
NumberOfCustomItems: "Custom Fields",
NumberOfFullPriceTickets: "Full-Fare Tickets",
NumberOfGuestsPerRoom: "Adults per Room",
NumberOfRoom: "Rooms",
NumberOfRooms: "Rooms",
NumberOfRoomsAndOccupancy: "Rooms & Sleeps",
NumberOfRoomsAndPeople: "Rooms / Guests",
NumberOfRoomsBooked: "Rooms Booked",
NumberOfSheets: "Quantity",
NumberOfTrainTickets: "Train Tickets",
NumberOfWorkers: "Staff",
NumberProtecting: "Number Masking Enabled",
NZD: "NZD",
OccupySeatOverCountRemindContent: "If you cancel successfully confirmed ticket requests 3 times within a single day (canceling 5 times for 'No Seat' or tickets that do not match your berth preferences counts as 1 cancellation), you will be barred from purchasing tickets via 12306 for the rest of the day.",
OffAndBelow: "Off & Below",
OfficialOrderNo: "Official Order No.",
OfflineReservation: "Offline Booking",
OK: "OK",
OldAndNewPasswordsMustNotBeTheSame: "New password cannot be the same as the old password.",
OldVersion: "Use Old Version",
OneAirlineCanOnlyAddOneFrequentTravelCard: "Only one frequent flyer card can be added per airline.",
OneClickFill: "One-Click Fill",
OneKeyAlarm: "SOS",
OneKeyAlarmTripShare: "Once SOS is activated, itinerary details will be shared with emergency contacts automatically.",
OneWay: "One-way",
OnlineChangeNotSupported: "Online changes not supported",
OnlineCheckIn: "Online Check-in",
OnlineCheckInUnavailable: "Online check-in is not available. We recommend downloading the TravelSky App to complete check-in smoothly.",
OnlineCheckInViaUmetrip: "Online check-in is currently unavailable. Please use the Umetrip app to check in.",
OnlineFlight: "Check-in",
OnlineFlight_1: "Check-in",
OnlineFlightWarn: "Note: Online check-in service is provided by the airline. Please contact the airline directly for any issues.",
OnlinePayment: "Online Payment",
OnlinePayment_1: "Pay Online",
OnlineReport: "Online Reports",
OnlineSeatSelection: "Seat Selection",
OnlineService: "Customer Service",
OnlyAdultTicketBookingsAreSupported: "Adult ticket bookings only",
OnlyDirectFly: "Direct Flights Only",
OnlyMe: "My Trips Only",
OnlySeeSelected: "Selected Only",
OnlySupportsQueriesForDateRangesWithinOneYear: "Queries are restricted to a maximum date range of 1 year.",
Open: "Enable",
Open_1: "Enable",
Open_2: "Open",
OpenEnterpriseCode: "Enable Corporate Code",
OpenEnterpriseCodeStepTip: "Follow the steps below to activate Enterprise Code (about 1 minute):",
OpenHengshunTraveMobilelEditionForBetterExperience: "Open Homsom Mobile for a better experience",
OpenSafari: "Open in Safari",
OpenSuccess: "Enabled successfully",
OpenYears: "Opening Year",
OperatedBy: "Operated by",
Operating: "Processing",
Operation: "Actions",
Operator: "Processed By",
Optional: "Optional",
OptionalCities: "Available Cities",
OptionalDocuments: "Optional Documents",
OptionalInParentheses: "(Optional)",
OptionalInput: "Optional",
OptionalInput_1: "(Optional)",
OptionalReturnDate: "Select Return Date",
OrCopyLinkToBrowserPay: "Or copy the link to Safari or your default browser to complete payment",
Order: "Booking",
Order_1: "Book",
Order_2: "Booking Issues",
OrderCancelFailed: "Cancellation Failed",
OrderCancelled: "Cancelled",
OrderCompleted: "Completed",
OrderDate: "Booking Date",
OrderDateBookTime: "Booking Time",
OrderDetails: "Booking Details",
OrderFilling: "Booking Information",
OrderInformation: "Booking Information",
OrderInformationForChange: "Change Booking Details",
OrderInformationForRefund: "Refund Booking Details",
OrderInformationRefund: "Refund Booking Details",
OrderIntergral: "Points Earned",
OrderNo: "Booking ID",
OrderNo_1: "Voucher Code",
OrderNoCannotBeEmpty: "Booking ID is required",
OrderNotice: "Notifications",
OrderNoticeDesc: "Get updates on ticketing and booking status",
OrderNumber: "Booking ID",
OrderNumber_1: "No.",
OrderPaid: "Paid",
OrderStatus: "Status",
OrderStatusHasChangedPleaseReOperate: "The booking status has changed. Please try again.",
OrderSubmissionSuccessFailed: "Submission Failed",
OrderSubmissionSuccessful: "Submitted Successfully",
OrderSynTime: "Sync Time",
OrderTime: "Booking Time",
OrderType: "Booking Type",
OrganizationalStructure: "Organization",
OriginalPrice: "Original Price",
OriginalSchedule: "Original Itinerary",
OriginFlightOrderNo: "Original Flight Booking ID",
OriginFlights: "Original Flight",
OriginOrderNumber: "Original Booking ID",
OriginTrip: "Original Itinerary",
OriginTripOrderNo: "Original Train Booking ID",
OrTryOurAppForMoreAccurateAndFasterFaceRecognition: "Or use our app for faster and more accurate facial recognition.",
Other: "Other",
OtherConsult: "Other Inquiries",
OtherInfo: "Additional Info",
OtherLoginMethods: "Other Login Methods",
OtherPolicy: "Other Policies",
OtherReasons: "Other reasons",
OtherWaysOpenInBrowser: "Other options: Open payment link in mobile browser",
OurAgreedAveragePrice: "Corporate Negotiated Avg Rate",
OurCompany: "Corporate",
OurExclusiveConsultantWillContactYouAsSoonAsPossible: "Our dedicated consultant will contact you shortly.",
OverseasMultiCity: "Multi-city",
OverseasServicePhone: "Overseas Hotline",
Overview: "Overview",
OverviewOfTickets: "Flight Summary",
PackUp: "Collapse",
PaidBoardband: "Paid Broadband",
PaidParking: "Paid Parking",
PaidPickUpService: "Paid Airport Pickup",
PaidWiFi: "Paid Wi-Fi",
PartialChange: "Partial Change",
PartialRefund: "Partial Refund",
Pass: "Approve",
Passenger: "Passenger",
PassengerDetails: "Passenger Details",
PassengerFlight: "Passenger",
PassengerFlightDetails: "Passenger Details",
PassengerFlightName: "Passenger Name",
PassengerInformation: "Passenger Info",
PassengerList12306: "12306 Passenger List",
PassengerName: "Passenger Name",
PassengersWhoNeedToRefund: "Passengers for Refund",
PassengersWhoNeedToReschedule: "Passengers for Change",
PassengersWithoutRefundableTickets: "No Refundable Passengers",
PassengerType: "Passenger Type",
PassengerVehicle: "Passenger",
PassengerVehicleDetails: "Passenger Details",
PassengerVehicleForChange: "Change Passenger",
PassengerVehicleForRefund: "Refund Passenger",
PassengerVehicleInfo: "Passenger Info",
PassengerVehicleName: "Passenger Name",
PassengerVehicleWhoNeedToRefund: "Passengers for Refund",
PassengerVehicleWhoNeedToReschedule: "Passengers for Change",
Password: "Password",
Password12306: "12306 password is not your Homsom password",
PasswordCanBeResetViaEmail: "Password can be reset via linked email",
PasswordCanBeResetViaPhone: "Password can be reset via linked mobile number + SMS code",
PasswordMustBeNoLessThanEightDigitsInLength: "Password must be at least 8 characters",
PasswordMustBeNoLessThanSixDigitsInLength: "Password must be at least 6 characters",
PasswordRuleDescription: "Password must be over 8 characters and contain both uppercase/lowercase letters and numbers",
PasswordsMustContainLettersAndNumbers: "Password must contain both letters and numbers",
PasswordUpdateSuccessful: "Password updated successfully",
Pay: "Pay",
PayAgain: "Retry Payment",
PayAtTheStore: "Pay at Hotel",
PayAtTheStoreAbout: "Pay at Hotel Approx.",
PayBackTips: "Order unpaid. Leaving means abandoning payment. You can resume payment in Order History.",
PayInformation: "Payment Information",
PayInformationDetails: "Payment Details",
Paying: "Processing payment...",
PayingEnterpriseLabel: "Paying Entity",
PayingOrQrExpired: "Payment in progress / QR code expired",
PaymentCompleted: "Payment completed",
PaymentFailed: "Payment Failed",
PaymentOnBehalfShareDesc: "Share with others to pay for you",
PaymentPermission: "Payment Permissions",
PaymentSerialNumber: "Transaction ID",
PaymentSuccessful: "Payment Successful",
PaymentSuccessfulContinueToPayTheNextOrder: "Payment successful. Proceed to pay the next order.",
PaymentTime: "Payment Time",
PaymentWay: "Payment Method",
PayNow: "Pay Now",
PayOrder: "Pay Order",
PayResultTimeout: "Payment verification timed out. Please check the order details later.",
PayType: "Payment Type",
PayTypeCompanyDesc: "Paid via corporate account",
PayTypeMixedDesc: "Out-of-policy expenses must be paid personally",
PayTypePersonalDesc: "Requires personal payment",
PdfDownload: "Download PDF",
PdfPreview: "PDF Preview",
PendForOperating: "Pending",
Pending: "Pending Approval",
Pending_1: "Request submitted (Pending approval)",
Pending_2: "Booked (Pending approval)",
Pending_3: "Request submitted",
Pending_4: "Pending review",
People10: "10-20 people",
People20: "20-40 people",
People40: "40-100 people",
PeoplePerRoom: "Guests per room",
PercentageOfPotentialSavings: "Potential Savings %",
PercentageOfRoomNights: "Room Nights %",
PercentageOfSavings: "Savings %",
PercentageOfSheets: "Ticket Count %",
PermanentResidence: "Long-term Residence",
PermissionDisabledTitle: "Permission Disabled",
PermissionRetryTitle: "Permission Request",
PermissionsRange: "Permission Scope",
Person: "Personal",
PersonAccount: "Personal Account",
Personal: "Personal",
PersonalInformation: "Personal Information",
PersonalPayment: "Personal Payment",
PersonalPermissions: "Personal Permissions",
PersonalReschedule: "Personal Change",
PersonalRescheduleTip1: "1. Checking 'Change for Personal Reasons' keeps the original business trip order unchanged and only applies the 'Personal Trip' tag to the newly submitted change request.",
PersonalRescheduleTip2: "2. All costs (including fare differences and carrier fees) must be personally borne. No approval workflows or policy checks will be triggered.",
PersonalRescheduleTip3: "3. Once the changed order is successfully issued as a 'Personal Trip', it cannot be converted back to a business trip order.",
PersonalTools: "Personal Tools",
PersonalTravelInformation: "Personal Travel Info",
PersonalTrip: "Personal Trip",
PersonalTrip_1: "Personal Trip",
PersonalWallet: "Personal Wallet",
PersonalWorkbench: "Personal Accounts",
PersonEntry: "Profile",
PhoneNumberFormatIsIncorrect: "Invalid mobile phone format",
PhoneNumberFormatIsIncorrect_1: "Invalid mobile number format",
PhoneNumberOrEmailFormatIsIncorrect: "Invalid mobile number or email format",
Photo: "Photo",
PhotoOrFile: "Photos/Files",
PickUpCity: "Pickup City",
PickUpUseCarTimeTenMinute: "10 mins after landing",
PickUpUserCarTimeFiftyMinute: "50 mins after landing",
PickUpUserCarTimeFourtyMinute: "40 mins after landing (Recommended for checked baggage)",
PickUpUserCarTimeSixtyMinute: "60 mins after landing",
PickUpUserCarTimeThirtyMinute: "30 mins after landing (Recommended for carry-on only)",
PickUpUserCarTimeTwentyMinute: "20 mins after landing",
Picture: "Image",
PlaceOfDeparture: "Leaving from",
PlaceOfService: "Destination",
Plan: "Original Schedule",
Plane: "Aircraft",
PlaneBookNoticeCopyTips: "Link copied. Previews are not supported in the Mini Program. Please open in a browser.",
PlaneConstruction: "Airport Tax",
PlaneConstructionFee: "Airport Construction Fee",
PlaneConstructionFuel: "Airport Tax/Fuel Surcharge",
PleaseAddARoomer: "Please add guests",
PleaseAddContact: "Please add a contact",
PleaseCancelRoomSelectTitle: "Select rooms to cancel",
PleaseCheckInAccordingToTheActualFlight: "Please check in based on your actual flight schedule.",
PleaseCheckTheBoxToAgreeAfterReadingTheRelevantTermsAndConditions: "Please read and agree to the terms and conditions.",
PleaseCheckUserCancelAgreement: "Please check the Account Deletion Agreement",
PleaseChoose: "Please select",
PleaseChooseAPlaceOfArrival: "Please select destination",
PleaseChooseAPlaceOfDeparture: "Please select departure location",
PleaseChooseASeat: "Select Seat",
PleaseChooseCarType: "Please select vehicle type",
PleaseChooseContacts: "Please select contacts",
PleaseChooseIDType: "Please select ID type",
PleaseChoosePayWay: "Please select payment method",
PleaseChoosesCabinLevel: "Please select cabin class",
PleaseChooseTheAirClub: "Please select frequent flyer program",
PleaseChooseTheDocumentSignatory: "Please select issuing country",
PleaseChooseTheHotelGroupMembership: "Please select hotel loyalty program",
PleaseChooseTheReason: "Please select a reason",
PleaseChooseTheReason_1: "Please select a reason:",
PleaseChooseTheValidityPeriodOfTheCertificate: "Please select expiration date",
PleaseChooseWhenToUseTheCar: "Please select pickup time",
PleaseChooseYourNationality: "Please select nationality",
PleaseCompleteTheReceiptInformation: "Please enter delivery information",
PleaseCompleteTheVerificationAsSoonAsPossible: "Please complete verification as soon as possible to avoid ticket issuance delays.",
PleaseCompleteYourGivenNames: "Please enter given name(s)",
PleaseCompleteYourNameInformation: "Please enter your full name",
PleaseCompleteYourSegments: "Please complete your itinerary",
PleaseCompleteYourSurname: "Please enter surname",
PleaseConfigureTheExaminerInTheBackground: "Please contact administrator to configure approvers in the backend.",
PleaseConfirmIfWeChatPaymentHasBeenCompleted: "Please confirm if WeChat Pay has been completed",
PleaseConfirmPassengerInfo: "Please confirm passenger information",
PleaseConfirmTheNewPassword: "Please confirm new password",
PleaseContactTheAccountNumber12306: "Please link your 12306 account",
PleaseDoNotRefreshThisPagePromptOperation: "Please do not refresh this page and follow the phone prompts",
PleaseEnableLocationPermissionOfCurrentApp: "Please enable location permission for the app",
PleaseEnter: "Please enter",
PleaseEnter_1: "Please enter keywords to search",
PleaseEnterAccurateAndCompleteUnitInformation: "Please enter accurate and complete company information",
PleaseEnterAComment: "Please enter notes",
PleaseEnterACostCenterName: "Please enter cost center",
PleaseEnterAddress: "Please enter street address",
PleaseEnterAddress_1: "Please enter address",
PleaseEnterAlipayAccount: "Please enter Alipay account",
PleaseEnterANewPassword: "Please enter a new password",
PleaseEnterASuggestionOfNoLessThanEightWords: "Please enter feedback (minimum 8 characters)",
PleaseEnterAUsername: "Please enter ID/Username",
PleaseEnterAuthorizationCode: "Please enter authorization code",
PleaseEnterBindingCredentialName: "Please enter ID number to link",
PleaseEnterBindingCredentialType: "Please select ID type to link",
PleaseEnterBindingMobile: "Please enter mobile number to link",
PleaseEnterBindingUserName: "Please enter name to link",
PleaseEnterCompnayInfo: "Please enter company name",
PleaseEnterContactName: "Please enter contact name",
PleaseEnterCorrectEmail: "Please enter a valid email address",
PleaseEnterCorrectMobile: "Please enter a valid mobile number",
PleaseEnterDestination: "Please enter destination",
PleaseEnterEheCorrectFormatOfValidityPeriod: "Please enter a valid expiration date (MM/YYYY)",
PleaseEnterInformation: "Please enter information",
PleaseEnterKey: "Please enter keywords",
PleaseEnterMobileVerification: "Please enter verification code",
PleaseEnterPhone: "Please enter recipient mobile number",
PleaseEnterPhoneNumberOrEmail: "Please enter mobile phone or email",
PleaseEnterRealName: "Please enter your real name",
PleaseEnterRecipient: "Please enter recipient name",
PleaseEnterRegisterInfo: "Please enter registration information",
PleaseEnterSMSCode: "Please enter SMS verification code",
PleaseEnterStartPoint: "Please enter departure point",
PleaseEnterTheAccountForRetrievePassword: "Please enter the account to reset password",
PleaseEnterTheAccountInformationYouNeedToRetrieveYourLoginPassword: "Please enter account details to reset login password",
PleaseEnterTheAirport: "Please enter airport name",
PleaseEnterTheArriveAddress: "Please enter drop-off location",
PleaseEnterTheBindingEmail: "Linked email address",
PleaseEnterTheBindingPhone: "Linked mobile phone",
PleaseEnterTheBindingPhoneNumberEmail: "Please enter linked mobile phone or email",
PleaseEnterTheBindingPhoneNumberEmail_1: "Linked mobile phone or email address",
PleaseEnterTheCardNumber: "Please enter card number",
PleaseEnterTheCardNumberOrUsername: "Please enter card number or username",
PleaseEnterTheCarRank: "Please enter vehicle travel standard",
PleaseEnterTheCity: "Please enter city name",
PleaseEnterTheCityNameToSearch: "Please enter city name to search",
PleaseEnterTheCompanyAddress: "Please enter company address",
PleaseEnterTheCorrectAccountPassword: "Please enter the correct username and password",
PleaseEnterTheCorrectCreditCardNumber: "Please enter a valid credit card number",
PleaseEnterTheCorrectMobilePhoneNumberEmail: "Please enter a valid mobile phone or email address",
PleaseEnterTheCorrectVerificationCode: "Please enter the correct verification code",
PleaseEnterTheCostCenter: "Please enter Cost Center to search",
PleaseEnterTheCountry: "Please enter country or region to search",
PleaseEnterTheCurrentPassword: "Please enter current password",
PleaseEnterTheCustomItems: "Please enter custom field to search",
PleaseEnterTheDepartAddress: "Please enter pickup location",
PleaseEnterTheDepartment: "Please enter department name to search",
PleaseEnterTheFlightBookPermission: "Please enter flight booking permission to search",
PleaseEnterTheHomeAddress: "Please enter home address",
PleaseEnterTheHotelBookPermission: "Please enter hotel booking permission to search",
PleaseEnterTheHotelCity: "City / Landmark / Hotel Name",
PleaseEnterTheIntlHotelCity: "City / Hotel Name",
PleaseEnterTheLastThreeDigitsOfTheCVVSecurityCode: "Please enter the last 3 digits of CVV",
PleaseEnterTheName: "Please enter name to search",
PleaseEnterTheNameOfThePerson: "Please enter guest name or booking ID",
PleaseEnterTheNameOfThePerson_1: "Guest name, booking ID, or hotel name",
PleaseEnterTheNameOfTheRank: "Please enter travel standard name to search",
PleaseEnterTheNameOfTheRole: "Please enter role name to search",
PleaseEnterTheNewPassword: "Must be 8–20 letters and numbers",
PleaseEnterTheOldPassword: "Please enter current password",
PleaseEnterThePassengerName: "Please enter passenger name or booking ID",
PleaseEnterThePassword: "Please enter login password",
PleaseEnterTheReason: "Please enter the reason (optional)",
PleaseEnterTheSystemRole: "Please enter the system role to search",
PleaseEnterTheTemplate: "Please enter the approval template name to search",
PleaseEnterTheTrainAccountNewPassword: "6–20 alphanumeric characters",
PleaseEnterTheTrainAccountNewPassword_1: "Please enter at least 6 characters",
PleaseEnterTheTrainBookPermission: "Please enter the train booking permission to search",
PleaseEnterTheTrainStation: "Please enter the train station to search",
PleaseEnterTheTraveler: "Please enter the name/email/mobile phone/staff ID to search",
PleaseEnterTheTraveler_1: "Search by Name/Email/Mobile Phone/Staff ID/Nickname",
PleaseEnterTheTraveler_2: "Search by Name/Mobile Phone/ID Number",
PleaseEnterTheUnitCodeOrUnitShortName: "Please enter the organization ID/abbreviation/full name",
PleaseEnterTheValidityPeriodOfTheCreditCard: "Please enter the credit card expiration date (MM/YY)",
PleaseEnterYourAccountInformation: "Please enter account information",
PleaseEnterYourChineseNameOrEnglishName: "Please fill in your name (Chinese or English)",
PleaseEnterYourExceedReason: "Please fill in the reason for out-of-policy travel",
PleaseEnterYourNewPasswordAgain: "Please enter your new password again",
PleaseEnterYourNewPasswordAgain_1: "Please confirm your password",
PleaseFill: "Please fill in",
PleaseFillBudget: "Please fill in the budget",
PleaseFillIn: "Please fill in the new mobile phone",
PleaseFillInAlipayAccount: "Please fill in Alipay account",
PleaseFillInCardNumber: "Please fill in the card number",
PleaseFillInCostCenterName: "Please enter the cost center",
PleaseFillInDepartmentName: "Please enter the department name",
PleaseFillInDiner: "Please fill in the guest's name",
PleaseFillInFirstName: "Please fill in the given name",
PleaseFillInGuestName: "Please fill in the guest's name",
PleaseFillInIDNumber: "Please fill in the ID number",
PleaseFillInLastName: "Please fill in the last name",
PleaseFillInName: "Please fill in the name",
PleaseFillInNewPhoneCurrentPhone: "Please fill in the new mobile phone. Current mobile phone: ",
PleaseFillInOrderNumber: "Please fill in the order number",
PleaseFillInPassengerName: "Please fill in the passenger's name",
PleaseFillInPhoneNumber: "Please fill in the mobile phone",
PleaseFillInPhoneOrEmail: "Please fill in mobile phone or email",
PleaseFillInRC: "Please enter the Reason Code",
PleaseFillInSendingEmail: "Please fill in the email address",
PleaseFillInTheContactMobilePhoneNumber: "Please fill in the contact mobile phone",
PleaseFillInTheReasonForRefund: "Please fill in the reason for refund",
PleaseFillInTheReasonForRescheduling: "Please fill in the reason for change",
PleaseFillInTheShippingAddress: "Please fill in the shipping address",
PleaseFillInVerificationCode: "Please fill in the verification code",
PleaseFillTheReason: "Please fill in the reason (optional)",
PleaseFillTotalBudget: "Please fill in the total budget",
PleaseFirstGoToLinkYourDidiAccount: "Please link your DiDi account first.",
PleaseGetTheVerificationCode: "Please get the verification code first.",
PleaseHoldDownTheSliderAndDrag: "Please hold down the slider and drag it to the far right",
PleaseHoldThePhoneVertically: "Please hold your phone vertically.",
PleaseInputCreditCardNumber: "Please enter the credit card number",
PleaseInputYourDestination: "Please enter your destination",
PleaseMakeSureYouHaveEnoughTimeToCheckIn: "1. Before purchasing, please go to the check-in counter to confirm that there is still enough time to check in after ticket issuance.",
pleaseOpenScanOnAlipayScanQRCodeToPay: "Please open Alipay, tap Scan, and scan the QR code to pay.",
pleaseOpenScanOnWeChatScanQRCodeToPay: "Open WeChat and use 'Scan' to scan the QR code for payment.",
PleasePressBackOnceToExit: "Press back again to exit",
PleaseReadAndAgreeTo: "Please read and agree to the 'Account Authorization Agreement'",
PleaseReadAndTickTheAgreementFirst: "Please read and accept the agreement",
PleaseReselectYourCheckInDate: "Please select your check-in date again",
PleaseScreenshotSaveQRCode: "Please take a screenshot to save the QR code",
PleaseSelectADepartureDate: "Please select departure date",
PleaseSelectADestination: "Please select destination",
PleaseSelectAirport: "Please select airport",
PleaseSelectApprover: "Please select approver",
PleaseSelectArea: "Please select location",
PleaseSelectArrival: "Please select destination",
PleaseSelectArrivalAirport: "Please select arrival airport",
PleaseSelectArrivalCity: "Please select destination city",
PleaseSelectArrivalTrainStation: "Please select arrival station",
PleaseSelectAtLeastOneCityOverseas: "Select at least one international or regional city",
PleaseSelectAtLeastOneOccupant: "Please select at least 1 guest",
PleaseSelectBackDate: "Please select return date",
PleaseSelectBusinessTravelScale: "Please select monthly business travel volume",
PleaseSelectCertificate: "Please select ID type",
PleaseSelectCertificateNo: "Please enter ID number",
PleaseSelectCostCenter: "Please select a cost center",
PleaseSelectDepartment: "Please select a department",
PleaseSelectDeparture: "Please select departure location",
PleaseSelectDepartureAirport: "Please select departure airport",
PleaseSelectDepartureTrainStation: "Please select departure station",
PleaseSelectDestination: "Please select city",
PleaseSelectDiner: "Please select guest",
PleaseSelectedTheCheckInDate: "Please select check-in date",
PleaseSelectFlightChangeDate: "Please select date for Change",
PleaseSelectFlightDate: "Please select flight date",
PleaseSelectFlightNumber: "Please enter flight number",
PleaseSelectGuest: "Please select guest",
PleaseSelectGuestLeastOne: "At least one guest is required for each room",
PleaseSelectHotelArrivalTime: "Please select arrival time",
PleaseSelectLoginTypeWitchAnytime: "Select Login Method",
PleaseSelectOrder: "Please select order",
PleaseSelectOrFillInMealsRemarks: "Please select or enter meal remarks",
PleaseSelectOrFillInPurpose: "Please select or enter purpose of travel",
PleaseSelectOrFillInTheReasonForCancelReason: "Please select or enter cancellation reason",
PleaseSelectOrFillInTheReasonForExceedingTheStandard: "Please select or enter reason for exceeding Travel Standard",
PleaseSelectOrFillInTheReasonForRefundReason: "Please select or enter Refund reason",
PleaseSelectOrFillInTheReasonForReschedulingReason: "Please select or enter Change reason",
PleaseSelectOrFillInTheReasonForViolatingTheTravelRank: "Please select or enter reason for exceeding Travel Standard",
PleaseSelectOrFillInTheReasonOrPleaseSelectTheMixedPayment: "Please select or enter reason for exceeding Travel Standard or select out-of-pocket payment",
PleaseSelectPassenger: "Please select Staff",
PleaseSelectPassengersFirst: "Please select a Staff first",
PleaseSelectPaymentWay: "Please select payment method",
PleaseSelectPermanentResidence: "Please select permanent residence",
PleaseSelectPurpose: "Please select travel purpose",
PleaseSelectSeats: "Please select seat",
PleaseSelectTheCardExpirationMonth: "Please select month",
PleaseSelectTheCardExpirationYear: "Please select year",
PleaseSelectTheCheckOutDate: "Please select check-out date",
PleaseSelectTheDateOfBirth: "Please select date of birth",
PleaseSelectTheDepartureCity: "Please select departure city",
PleaseSelectTheEndDate: "Please select end date",
PleaseSelectTheFavoriteToDeleteFirst: "Please select favorites to delete",
PleaseSelectTheFirstSeat: "Please select seat for leg 1",
PleaseSelectTheFollowingMethodsForVerification: "Please select a verification method",
PleaseSelectTheItineraryToBeRescheduled: "Please select trip to change",
PleaseSelectTheMixedPayment: "Please choose out-of-policy payment to continue booking",
PleaseSelectThePassengerWhoNeedsToChange: "Please select passenger for change",
PleaseSelectThePassengerWhoNeedsToRefund: "Please select passenger for refund",
PleaseSelectThePassengerWhoNeedsToReschedule: "Please select trip to change",
PleaseSelectTheRoomAndRoomer: "Select Room & Guests",
PleaseSelectTheSecondSeat: "Please select seat for leg 2",
PleaseSelectTheShippingAddress: "Please select shipping address",
PleaseSelectTheStationWhereYouWillBePickedUp: "Please select pick-up station",
PleaseSelectTheTravelApplication: "Please select travel request",
PleaseSelectTheTypeOfQuestion: "Please select question type",
PleaseSelectTrainStation: "Please select train station",
PleaseSelectTraveler: "Please select traveler",
PleaseSendTheAbovePaymentTo: "Please remit the above amount by",
PleaseSure: "Please confirm that",
PleaseUseTheFollowingCreditCard: "Tips: Only the following credit cards are supported",
PleaseVerifyThatYouHaveAFaceIDForLogin: "Please verify Face ID to log in",
PleaseVerifyThatYouHaveATouchIDForLogin: "Please verify Touch ID to log in",
PointYourFaceAtTheFrontCameraOfYourPhone: "Please look directly into the front camera",
PoliciesServices: "Policies & Services",
Policy_1: "Policy",
PolicyAddress: "Policy Address",
PolicyNoColon: "Policy No.:",
PopularDestinations: "Popular Destinations",
PopularFilters: "Popular Filters",
PopularRoutes: "Popular Routes",
Pptimization: "Recommended Options",
Precautions: "Important Notes",
Preferential: "Discounts",
Preferential_1: "Applicable Offers",
PremiumHotel: "Upscale",
PremiumHotel_1: "Upscale",
Prepay: "Prepay",
Prepayments: "Prepayment",
PreQuantifier: "/Person",
PressVoice: "Hold to Talk",
Preview: "Preview",
PreviewNotSupportedAndIsCopy: "Preview not supported. Copied to clipboard, please open in a browser.",
Price: "Price",
Price1000_1300: "¥1,000-1,300",
Price1300_1800: "¥1,300-1,800",
Price150: "Under ¥150",
Price150_300: "¥150–300",
Price300_450: "¥300–450",
Price400: "Under ¥400",
Price400_700: "¥400–700",
Price450_600: "¥450–600",
Price600_1000: "¥600–1,000",
Price700_1000: "¥700–1,000",
Price_1: "Estimated Fares",
Price_2: "Stars & Price",
PriceCeiling: "Price Cap",
PriceDetails: "Price Details",
PriceHighest: "High to Low",
PriceHighToLow: "Price: High to Low",
PriceHotel: "Room Rate",
PriceLowest: "Low to High",
PriceLowToHigh: "Price: Low to High",
PriceOver1000: "¥1,000+",
PriceOver1800: "¥1,800+",
PriceRating: "Price/Star Rating",
PriceRating_1: "Price/Diamond Tier",
PriceSingleChoice: "Price (Single Selection)",
Print: "Print",
PriorityHighPrice: "Highest Price First",
PriorityHighRating: "Top Stars First",
PriorityLowPrice: "Lowest Price First",
PrivacyNumberProtection: "Privacy Number Protection",
PrivacyPolicy: "Privacy Policy",
ProceedToBind: "Link Now",
Processing: "Pending",
ProcessingCompleteTime: "Completed At",
ProcessingNotes: "Instructions",
ProcessingProcedure: "Process",
ProcessingTime: "Processing Time",
ProcessingTime_1: "Processing Duration",
ProduceDesc: "Product Description",
ProduceName: "Product Name",
Product: "Product",
ProductDesc: "Product Details",
ProductExperience: "Product Feedback",
ProductId: "Product ID",
ProductIntroduction: "Product Overview",
ProductOverview: "Product Summary",
ProductUseRuleDes: "Terms of Use",
Progress: "In Progress",
PromptDateHotel: "Dates are based on the hotel's local time.",
PromptDatePrice: "Dates are based on departure location time. Prices fluctuate and are subject to final booking.",
ProportionOfContractedHotelStarLevelTransactions: "Spend Share by Corporate Hotel Star Rating",
ProportionOfHotelRoomNightsInAgreement: "Corporate Room Nights Share",
ProportionOfNetTransactionPrice: "Net Spend Share",
ProportionOfRCTimes: "RC Rate",
PullToRefresh: "Pull to refresh",
PullUpLoadMore: "Pull up to load more",
Punctuality: "On-Time Rate",
PutTheQRCodeIntoTheBox: "Align QR code within the frame to scan.",
QrCode: "QR Code",
QRCodeHasExpired: "QR code expired",
Quantity: "Tickets",
Quarterly: "Quarterly",
QueryConditions: "Filter Criteria",
QueryNotJurisdiction: "No permission to view",
QueryQuoteErrors: "Failed to fetch quotation",
QueryRange: "Query Scope",
QueryResultOfTheCurrentCity: "Results for Current City",
QueryType: "Query Type",
QuickSelection: "Quick Select",
RankInformation: "Travel Standard Info",
RankManagement: "Travel Standard Management",
RankName: "Travel Standard Name",
Rating: "Star rating",
RatingHighToLow: "Stars: High to Low",
RatingLowToHigh: "Stars: Low to High",
RatingMultipleChoice: "Stars (Multi-select)",
RCContent: "RC Content",
RCManagement: "RC Management",
RCType: "RC Type",
Read: "Read",
Reapply: "Resubmit Request",
Reason: "Reason",
ReasonForNotSelectingTheCheapestFlight: "Reason for Not Choosing Lowest-Priced Flight",
ReasonForNotSelectingTheLowestPrice: "Reason for Not Choosing Lowest Price",
ReasonForRejection: "Rejection Reason",
ReasonForTheRefundTicket: "Refund Reason Type",
ReasonForTicketIssueFailure: "Reason for Issuance Failure",
ReasonForTravelRankingViolation: "Reason for Out-of-Policy Travel",
ReasonsForBusiness: "Purpose of Trip",
ReBook: "Book Again",
ReceiveMode: "Receiving Method",
RecentlyVisited: "Recently Viewed",
RecentSearches: "History",
Recharge: "Top Up",
RechargeAmount: "Top-up Amount",
Recommend: "Recommended",
Recommend_1: "Top Recommendations",
RecommendCabinPrice: "Recommended option for the same flight:",
Recommended: "Recommended",
RecommendedFlights: "Recommended Flights",
RecommendedTransferFlights: "Recommended Connecting Flights",
RecommendForYou: "Recommended for You",
RecommendReason: "Reason for Recommendation",
RedirectFailedTryOtherMethod: "If payment fails to redirect, please try Method 2 or Method 3.",
RedirectToDiDiCarHailing: "Go to DiDi Ride-Hailing",
ReElection: "Change Cabin",
RefreshFlight: "Refresh Flights",
RefreshPageTip_1: "Approval status has changed. Refresh the page to update.",
RefreshPrices: "Refresh Prices",
RefreshQrCode: "Refresh QR Code",
RefreshRetry: "Please refresh and try again.",
RefreshSucceed: "Refreshed",
Refund: "Refund",
Refund_1: "Refund",
RefundAmount: "Refund Amount",
RefundAmountPendingApproval: "Refund Amount Pending Approval",
RefundApprovalFlow: "Refund Approval Workflow",
RefundCertificate: "Refund Certificate",
RefundChangeAndBaggageInstructions: "Refund, Change & Baggage Policy",
RefundDetails: "Refund Details",
RefundFailed: "Refund Failed",
RefundFee: "Refund Fee",
Refunding: "Refund in Progress",
RefundInstructions: "Refund Policy",
RefundOrChangeExplain: "Refund & Change Policy",
RefundOrder: "Refund Order",
RefundOrderDate: "Refund Request Date",
RefundOrderDetails: "Refund Details",
RefundOrderNumber: "Refund Order No.",
RefundOrderReason: "Reason for Refund",
RefundOrderTime: "Refund Request Time",
RefundPassenger: "Refund Passenger",
RefundPolicy: "Refund Policy",
RefundRate: "Refund Rate",
RefundReason: "Reason for Refund",
RefundSucceed: "Refund Successful",
RefundTicket: "Refund",
RefundTrip: "Refunded Segment",
Regard: "Follow",
RegardEmployees: "Following",
RegardFailed: "Failed to follow",
RegardSuccess: "Following",
Register: "Register",
Register_1: "Registration Info",
Register_2: "Mobile Verification",
Register_3: "Pending Approval",
RegisterNow: "Register Now",
RegisterSuccess: "We will contact you as soon as possible. Please keep your phone available. Thank you!",
ReimbursementVoucher: "Reimbursement Voucher",
ReissueInvoice: "Reissue Invoice",
Reject: "Reject",
Rejected: "Rejected",
RelationAccount: "Link Account",
RelationLogin: "Link & Log In",
RelationToHOMSOM: "Please link your account",
ReleaseImmediateLoad: "Release to load",
ReleaseImmediateRefresh: "Release to refresh",
ReleaseSendSlideUpCancel: "Release to send, swipe up to cancel",
ReleaseToCancel: "Release to cancel",
ReleaseVoice: "Release to send",
Relevance: "Link",
Relocate: "Relocate",
RemainingEnterpriseCodePayPrefix: "Time remaining for Corporate Code payment:",
RemainingSubmitTicketIssuePrefix: "Time remaining for submission:",
Remarks: "Notes",
ReminderYouCanImportFrequentTravelerInFrequentTravelerManagement: "Note: You can also add frequent travelers by importing member profiles in Frequent Traveler Management.",
RemovalFailedPleaseTryAgainLater: "Failed to remove. Please try again later.",
RemoveFrequentTraveller: "Remove Frequent Traveler",
RemoveFromTheTiedList: "Unlink Account",
RemoveSuccessful: "Removed successfully",
RemovetheCostCenter: "Delete Cost Center",
RemoveTheDepartment: "Delete Department",
RemoveTheEmployee: "Delete Staff",
RemoveTheNonEmployee: "Delete External User",
RemoveTheRC: "Delete RC",
RemoveThisFrequentContact: "Delete Frequent Contact",
RenovationYears: "Renovation Year",
ReportName: "Report Name",
ReportTotal: "Total",
ReQuery: "Search again",
RequiredChoose: "Required",
RequiredChooseArrivalCityAddressDesc: "(Required) All stopover cities must be added",
RequiredChoosePleaseChoose: "(Required) Please select",
RequiredChooseUneditable: "(Required) Not editable",
RequiredDocuments: "Required Materials",
RequiredFill: "Required",
RequiredFillPleaseFill: "(Required) Please fill in",
RequiredFillPleaseFillOrChoose: "(Required) Please enter or select",
RequiredFillUneditable: "(Required) Not editable",
RequiredReadingForBook: "Essentials",
RequiredReadingForChange: "Change Policy",
RequiredReadingForHotel: "Essentials",
RequiredReadingForRefund: "Refund Policy",
RequiredReadingForTrainChange: "Change Policy",
ReReserveSeat: "Re-lock seat",
ReScan: "Rescan",
Reschedule: "Request Change",
Rescheduled: "Change",
Rescheduling: "Change Itinerary",
ReschedulingApprovalFlow: "Change Approval Workflow",
ReschedulingFee: "Airline Change Fee",
ReschedulingReason: "Reason for Change",
ReSearch: "Search again",
Reselect: "Select again",
Reselect_1: "Reselect Outbound",
ReselectFlight: "Reselect Flight",
ReSelectPrice: "Reselect Price",
Resend: "Resend",
ResendConfirmationMessage: "Resend Confirmation",
ResendPleaseWait: "Resending, please wait...",
ResendReimbursementVoucher: "Resend Voucher",
ReservationBeforeDidi: "Before booking a ride on Didi, you must complete a request form. If you are unsure how to use it,",
ReservationOrder: "Request Form",
ReserveApproverNameColon: "Alternative Approver:",
ReserveCar: "Book a Ride",
ReserveNow: "Book Now",
ReserveSeat: "Lock seat",
ReserveUseCar: "Book a Ride",
Reset: "Reset",
ResetFilter: "Reset",
ResetPassword: "Reset Password",
ResetPwdSuccess: "Booking password reset successfully, return to continue payment",
ResetUsingBoundEmail: "Reset via linked email",
ResetUsingBoundPhoneNumber: "Reset via linked mobile number",
Result: "Search Results",
RetrieveByEmail: "Find via Email",
RetrieveByMobile: "Find via Mobile Number",
RetrievePassword: "Forgot Password",
RetrievePasswordByMobile: "Find via Mobile Number",
Retry: "Retry",
Return: "Return",
ReturnAndChangeInstructions: "Change & Refund Policy",
ReturnColon: "Return:",
ReturnDate: "Return Date",
ReturnFilter: "Return Filters",
ReVetting: "Resubmit Request",
RevisedFlightInformation: "New Flight Details:",
ReviseTheDifference: "Fare Difference",
RideInfo: "Ride Info",
RMBNight: "CNY/Night",
RoleDescription: "Description",
RoleDetail: "Role Details",
RoleManagement: "Role Management",
RoleName: "Role Name",
Room: "Room",
Roomer: "Guest",
RoomerDetails: "Guest Details",
RoomerName: "Guest Name",
RoomFees: "Room Rate",
RoomNight: "Room Nights",
RoomsAndGuests: "Rooms & Guests",
RoomType: "Room Type",
RoomTypeDetails: "Details",
RoomTypeRemarks: "Room Notes",
RoundTrip: "Round-trip",
Route: "Route",
RouteType_1: "One-way / Round-trip",
RUB: "RUB",
Rules: "Rules",
SafetyAlarmRequired: "Emergency Alarm Guide",
SafetyManage: "Security",
SafetyReminder: "Please fasten your seatbelt, travel safely, and take all your belongings before exiting.",
SalesPrice: "Price",
SameLevelApprover: "Co-approvers",
SameStationTransfer: "Same-Station Transfer",
Save: "Save",
Save_2: "Save Changes",
Save_3: "Saved",
SaveFailed: "Save failed",
SaveFailedFromCode: "Failed to save QR code",
SaveInfo: "Save Info",
SaveOrderError: "Failed to save the booking. Please return to the flight search page and try again.",
SaveQRCode: "Save QR Code",
SaveSucceed: "Saved successfully",
SaveSucceedToPhotoLibary: "Saved to album",
SavingAnalysisofBookinginAdvance: "Advance Booking Savings Analysis",
SavingAndMissedSaving: "Savings Analysis",
Savings: "Amount Saved",
SavingsLosses: "Savings & Losses",
ScaleLevel_1: "10k - 30k",
ScaleLevel_2: "30k - 100k",
ScaleLevel_3: "100k - 300k",
ScaleLevel_4: "300k - 1M",
ScaleLevel_5: "Over 1M",
ScanAndLogin: "Scan to Log In",
ScanCodeLogin: "Scan QR Code to Log In",
ScannedAccountVerification12306: "Your 12306 account needs verification. Please complete it via the link below to ensure successful bookings.",
ScannedOCchoose: "Or Select Manually",
ScanQrByAlipay: "Please scan the QR code with Alipay to complete payment",
ScanQRCodePay: "Scan QR Code to Pay",
ScanSuccessfully: "Scan successful",
ScanTheQRCode: "Scan QR Code",
Schedule: "Timetable",
ScheduleConflictTip: "Schedule Conflict Alert",
ScheduledItinerary: "Booked Trips",
ScheduleTip: "Note: Schedules are subject to actual operation. Please stay tuned to station announcements.",
Search: "Search",
Search_1: "Search",
Search_2: "Search",
Search_3: "Search",
SearchCanBeRescheduled: "Search Changeable Flights",
SearchFlight: "Search Flights",
SearchForMoreCities: "Search more cities",
SearchHistory: "Recent Searches",
SearchHistory_1: "Recent Searches",
SearchHotel: "Search Hotels",
Searching: "Searching...",
SearchThisArea: "Search this area",
SearchTrain: "Search Trains",
Seat: "Seat",
SeatInfo: "Seat Selection Info",
SeatNumber: "Seat No.",
SeatSelectionDepartingTrip: "Select Seat (Depart)",
SeatSelectionReturnTrip: "Select Seat (Return)",
SeatSelectionSucceed: "Seat selected successfully",
SecondClass: "Second Class",
SecondStep: "Step 2",
SecurityAlarmDesc: "In case of danger, please call 110 immediately.",
SecurityAssistant: "Security Assistant",
SecurityCenter: "Security Center",
SecurityCode: "Security Code",
See: "View Deals",
SeeAll: "View All",
Select: "Selected",
SelectAddressOnMap: "Select location on map",
SelectAll: "Select All",
SelectApprover: "Select Approver",
SelectAtLeastOneColumn: "Please select at least one field to export.",
SelectCabin: "Select Cabin Class",
SelectCarPlatform: "Select Ride-Hailing Platform",
SelectCarScene: "Select Purpose",
SelectCarUsageSceneRequired: "Please select a car usage scenario as required by your company policy.",
SelectCity: "Select City",
SelectCityWithAirport: "Please select a city with an airport",
SelectConfirmationOrder: "Select Confirmation Voucher",
SelectContact: "Select Contact",
SelectCustomItems: "Select Custom Field",
SelectDate: "Select Date",
SelectDeparting: "Select Outbound",
SelectDriverContactObject: "Please select who the driver should contact",
Selected: "Select",
Selected_1: "Selected",
SelectedAddress: "Select Location",
SelectedAsGoing: "Select as Outbound",
SelectedFlight_1: "Selected Flight",
SelectedFlights: "Flight Selected",
SelectedFlightsForYou: "Recommended Flights for You",
SelectedPassengers: "Passenger Selected",
SelectedPassengerVehicle: "Passenger Selected",
SelectEmployees: "Select Staff",
SelectEnglishSurname: "Please select Last Name (English)",
SelectFlight: "Select Flight",
SelectFlightChangeInfo: "Select flight to change",
SelectFlightChangeStep1: "01. Select passenger to change flight",
SelectFlightChangeStep2: "02. Select flight to change",
SelectFlightChangeStep3: "03. Select new date",
SelectFlightOnline: "Select Flight for Check-in",
SelectFlightRefund: "Select Flight for Refund",
SelectFlightRefundInfo: "Select flight information for refund",
SelectFlightRefundStep1: "01. Select passenger for refund",
SelectFlightRefundStep2: "02. Select flight for refund",
SelectFlightRescheduling: "Select Flight to Change",
SelectFollowUser: "Please select users to follow",
SelectFromTheAlbum: "Choose from Photos",
SelectInAlipayCashier: "Please select within Alipay Cashier",
SelectInvoicingType: "Select Invoice Type",
Selection: "Seat Selection",
SelectionResult: "Seat Selection Results",
SelectLanguage: "Select Language",
SelectOneWay: "One-Way",
SelectOrderExportFields: "Select Export Fields",
SelectPassengers: "Select Passengers",
SelectPolyphone: "Select Correct Pronunciation",
SelectReimbursementVoucher: "Select Receipt",
SelectReport: "Select Report",
SelectReturn: "Round-Trip / Return",
SelectTheCardExpirationMonth: "Select Month",
SelectTheCardExpirationYear: "Select Year",
SelectTheNumberOfRooms: "Select Rooms",
SelectThePassenger: "Select Passengers",
SelectThePassengerVehicle: "Select passengers",
SelectTheReasonForTheRefundTicket: "Select Refund Type",
SelectTheRescheduleType: "Select Change Type",
SelectTheStartingPointAndDestination: "Select Origin & Destination",
SelectTrain: "Select Train",
SelectTrainChangeInfo: "Select Change Info",
SelectTrainChangeStep1: "Select Staff to Change",
SelectTrainChangeStep2: "Select Journey to Change",
SelectTrainRefundInfo: "Select Refund Info",
SelectTrainRefundStep1: "Select Staff to Refund",
SelectTrainRefundStep2: "Select Journey to Refund",
SelectTrainRescheduling: "Select Journey to Change",
SelectYourCabin: "Select Cabin",
SelectYourSeatDeparting: "Select Outbound Flight",
SelectYourSeatReturn: "Select Return Seat",
Self: "Myself",
SelfPay: "Personal Expense",
SelfServiceChange: "Change Ticket for Myself",
SelfServiceRefund: "Refund Ticket for Myself",
Send: "Send",
SendATo12306: "Send to 12306",
SendCancelOrderEmail: "Send Refund Success Email",
SendCancelOrderSms: "Send Refund Success SMS",
SendDistressMessage: "Send SOS",
SendEmail: "Send to Email",
SendEmailOrPhone: "Send to Phone/Email",
SendFailure: "Failed to Send",
SendingLXD: "Send Travel Beans",
SendMail: "Send Email",
SendMailSuccessfullyPleaseCheckTheMailboxToResetThePassword: "Email sent. Please check your inbox to reset your password.",
SendMoneyToTheFollowingAccount: "Transfer to the Following Account",
SendSMS: "We have sent a message to",
SendSMS_1: "A verification code has been sent via SMS. Please enter it.",
SendSMS_2: "Send SMS",
SendSMSNotification: "Send SMS Notification",
SendSucceed: "Sent Successfully",
SendToEmail: "Send to Email",
SendVerificationCode: "Send Code",
SendVerificationCode12306: "Send SMS '666' to 12306",
SeniorApprover: "Line Manager",
SerialNumber: "Transaction No.",
Service: "Support",
Service_1: "Live Agent",
ServiceAgreement: "Terms of Service",
ServiceFee: "Service Fee",
ServiceLife: "Validity Period",
SetAsDefaultContact: "Set as Default Contact",
SetAsStaff: "Set as Staff",
SetBookingPwd: "Set Booking Password",
SetCompanyAddress: "Set Company Address",
SetEmergencyContact: "Set Emergency Contact",
SetHomeAddress: "Set Home Address",
SetNewPassword: "Set a new password",
SetNewPhoneNumber: "Set New Mobile Phone",
SetPwdSuccess: "Booking password set successfully, return to continue payment",
SetPwdTipBeforeCorpPay: "Per your company policy, set a booking password before using corporate payment",
SetSuccessfully: "Setting successful",
Setting: "Settings",
SettlementMethod: "Settlement Method",
SettlementPeriod: "Settlement Cycle",
SettleNow: "Immediate Settlement",
SGD: "Singapore Dollar",
SharedFlight: "Codeshare Flight",
SharePDF: "Share PDF",
ShareWithFriends: "Share with Friends",
ShippingAddress: "Shipping Address",
ShowAvailableTicketsOnly: "Available Only",
ShowMoreSuppliers: "More Suppliers",
ShowTheFrontOfYourFace: "Show Your Full Face",
SigningPolicy: "Endorsement Rules",
SignOut: "Sign Out",
SignOut_1: "Sign Out",
SignResultTimeout: "Contract status verification timed out. Please retrieve authorization manually or try again.",
SignSuccess: "Signed successfully",
Skip: "Skip",
SkipLogin: "Continue as Guest",
SliderDrag: "Slide right to complete puzzle",
SlideUpToSeeMore: "Swipe Up for More",
SlideYourFingerUp: "Swipe Up to Cancel",
Smoke: "Smoking",
SMS: "SMS Verification",
SMSVerification: "SMS Verification",
SnatchCodeWarn_1: "More train options, higher success rate",
SnatchCodeWarn_2: "Fare difference refunded automatically",
SnatchInfo: "Ticket Grab Info",
SnatchSeatsWarn_1: "· More seats, higher success rate",
SnatchSeatsWarn_2: "· Highest fare charged temporarily; refunded if final price is lower.",
SnatchTicket: "Ticket Grab",
SnaTchTicketDetails: "Ticket Grab Details",
SoldOut: "Sold Out",
SorryCantFind: "No Results Found",
SorryNoCabinAvailable: "No Cabins Available",
SorryNoFilterFlight: "No Matching Flights",
SorryNoFilterTrain: "No Matching Trains",
SorryNoMatchingFlight: "No Matching Flights",
SorryNoMatchingHotel: "No Matching Hotels",
SorryNoMatchingRoom: "No matching room types found",
SorryNoMatchingTrain: "No matching trains found",
SorryNoSearchFlight: "No flights available",
SorryNoSearchTrain: "No trains available",
SorryThePageYouVisitedDoesNotExist: "Page Not Found",
Sort: "Sort by",
SortDepartureEarlyToLate: "Departure (Earliest)",
SortDepartureLateToEarly: "Departure (Latest)",
SortPrice: "Price",
SortPriceHighToLow: "Price (High to Low)",
SortPriceLowToHigh: "Price (Low to High)",
SortRecommend: "Recommended",
SortTime: "Time",
SpecialLineForTravelConsultants: "Travel Advisor Hotline",
SpecialOffer: "Deals",
SpecificRequirements: "Requirements",
Spending: "Expenses",
Staff: "Staff",
StaffAdd: "Add Staff",
StaffNo: "Staff ID",
StarComfort: "3-Star",
StarComfort_1: "3-Diamond",
StarEconomic: "2-Star & Below",
StarEconomic_1: "2-Diamond & Below",
StarLuxury: "5-Star",
StarLuxury_1: "5-Diamond",
StarPremium: "4-Star",
StarPremium_1: "4-Diamond",
StarRating: "Rating",
Start: "Start",
StartDate: "Start Date",
StartVerification: "Start Verification",
StationDropOff: "Station Drop-off",
StationName: "Name",
StationPickup: "Station Pickup",
StationTransferService: "Station Transfer",
StatisticalBillNumber: "Statement No.",
StatisticalDate: "Statistics Date",
StatisticalDimension: "Dimension",
StatisticalMethod: "Statistics Scope",
StatisticsByUnit: "By Organization",
Status: "Status",
Stay: "Stay",
StayDuration: "Duration",
Stayed: "Visited",
StepOneCopyShareCodeOpenAlipay: "1. Copy code and open Alipay",
StepOneOpenAlipay: "1. Open Alipay",
StepOneOpenAlipayScan: "1. Open Alipay and scan QR code",
StepTwoClickAgreeAndUse: "2. Tap Agree and Continue",
StillLeave: "Leave Anyway",
Stop: "Stopover",
StopInfo: "Stopover Info",
StowMoreSuppliers: "Collapse Suppliers",
SubmissionDate: "Submission Date",
SubmissionTime: "Submission Time",
Submit: "Submit",
Submit_2: "Submit",
SubmitAndJumpDidi: "Submit and Go to Didi",
SubmitAndPay: "Submit & Pay",
SubmitOrder: "Submit Order",
SubmitOrderForChange: "Submit Change Order",
SubmitOrderForChange_1: "Submit Change Request",
SubmitOrderPaymentDescription: "Submit order and complete ticket purchase via Alipay Enterprise Payment",
SubmitSucceed: "Submitted",
Submitted: "Submitted",
SubmittedMaterials: "Submitted Materials",
SubmittedOn: "Submitted On",
SubmittedRefund: "Submit Refund",
SubmitTicketIssue: "Submit ticket issue",
SubmitVetting: "Submit for Approval",
Subsidiary: "Points Details",
SubwayStation: "Subway Station",
SuccessfulPasswordModification: "Password Updated",
SuggestMultipleChoices: "Multiple Selection Recommended",
SuggestUpdateOrClearFilter: "Modify or Clear Filters",
SuperEconomyClass: "Premium economy",
SuperiorCostCenter: "Parent Cost Center",
SuperiorDepartment: "Parent Department",
SupportImageAndPdfOnly: "Only Images and PDF Files Supported",
SupportingMixedPayment: "Supports Out-of-Policy Payment",
Surname: "Last Name (Pinyin)",
SurnameEgLI: "e.g. HAN",
SurnameHint: "For example, Wang Dawei should be entered as WANG.",
Surplus: "Remaining",
SwimmingPool: "Swimming Pool",
SwipeVerification: "Slide to Verify",
Switch: "Change",
SwitchAccount: "Switch Account",
SwitchAccountGo: "Switch Account to Continue",
SwitchAndAccess: "Switch and Access",
SwitchPerson: "Switch to Personal",
SwitchPersonAccount: "Switch to Personal Account",
SwitchUnit: "Switch Organization",
SwitchUnitAccount: "Switch to Corporate Account",
SyncDate: "Sync Date",
SystemApproval: "System Approval",
SystemBusy: "System Busy. Please Try Again Later.",
SystemPermissionCamera: "Camera Permission Required",
SystemPermissionDevice: "Storage Permission Required",
SystemPermissionInstall: "Permission Required",
SystemPermissionLocation: "Location Permission Required",
SystemRecommendedPrice: "Recommended Price",
SystemRole: "System Roles",
TakeAPicture: "Take Photo",
TakeOffTimeAnalysis: "Departure Time Analysis",
TakesOff: "Departure",
TalkAboutYourSuggestionOrProblem: "Share Your Feedback",
Taxi: "Taxi",
TaxIdOnlyEnglishOrNumbers: "Tax number must be Letters or Number",
TaxpayerIDNumber: "Tax ID",
TaxRegisterAddress: "Tax Registration Address",
TeamLink: "Team Link",
TeamQRcode: "Team QR Code",
Telephone: "Phone",
TemplateApprovalByDesignatedApprover: "Approval routing follows the designated approver selected during booking",
TemplateBound: "Linked to Other Templates",
TemplateName: "Template Name",
TemplateNotes: "Template Notes",
ThankYouForYourFeedback: "Thank you for your feedback",
THB: "Thai Baht",
TheApplicationFormYouHaveSelectedNotSupportRoundTripSwitching: "The selected request form does not support round-trip switching",
TheCarryingRegulationsFor: "Regulations for carrying lithium batteries and power banks on flights",
TheCityHasBeenSelected: "City Selected",
TheCodeValueIsEmpty: "Code is empty",
TheCurDatCanExcTheNexTriDatPleGoBacToTheHomPagToModify: "Current date cannot be later than the next trip date. Please return to the home page to modify",
TheCurrentDeviceIsLockedOrNotBiometricEnabled: "Device is locked or biometrics not enabled",
TheCurrentDeviceSupportsFaceID: "Face ID is available. Enable it now?",
TheCurrentDeviceSupportsTouchID: "Fingerprint login is available. Enable it now?",
TheCurrentLogin: "Currently Logged In",
TheCurrentNetworkIsNotAvailable: "Network unavailable",
TheCurrentNetworkIsNotAvailable_1: "Network unavailable. Please check your connection",
TheCurrentOrderHasBeenSplitIntoMultipleOrdersPleaseGoToTheOrderListToView: "This order has been split into multiple orders. Please check the order list",
TheCurrentOrderIsAPersonalPaymentOrder: "This is a personal payment order. Please pay promptly after approval for ticket issuance",
TheCurrentOrderRequiresPersonalPayment1: "Personal payment required. Tickets will be issued after payment",
TheCurrentOrderRequiresPersonalPayment2: "Personal payment required. Confirmation will be completed after payment",
TheCurrentPointsAreNotEnoughToExchangeThisItem: "Not enough points to redeem this item",
TheCurrentServiceNeedsToUseLocation: "Location access required. Please enable it in Settings.",
TheCurrentTimeIsNotAvailableForAppointments: "The current time is unavailable for booking.",
TheDriverIsGoingToTheDestination: "Driver is heading to the destination",
TheDriverWillContactThePassenger: "The driver will contact the passenger.",
TheEmailNotificationHasBeenTurnedOn: "Email notification enabled. Email address cannot be empty.",
TheFlightCombinationYouSelectedCannotBeReserved: "The selected flight combination cannot be booked. Please book separately.",
TheFlightHasInsufficientTickets: "Insufficient seats available. Please select another flight.",
TheFollowingTimesAreLocalTime: "All dates are in local time",
TheHotelPicturesAreForReferenceOnly: "*Hotel images are for reference only. Actual room layout may vary upon check-in.*",
TheItineraryYouSelectedNotMatchTheApplicationForm: "The selected itinerary does not match the Request form.",
TheLengthOfTheViolationOfTheTravelRankCannotExceedXWords: "The reason for Policy Violation cannot exceed 50 characters.",
TheLoadingFailedTryAgain: "Loading failed. Please try again.",
TheLowestLogicalFareIsSuggestedAccordingToTheTravelPolicyOfYourCompany: "According to corporate policy, booking the lowest logical fare is recommended.",
TheLowestPriceForDomesticAirTicketIsNotSelected: "The lowest fare was not selected for the domestic flight. Please select a reason.",
Theme: "Highlights",
TheNetworkSignalIsPoor: "Network connection error. Please try again later.",
TheNewPassword: "New password",
TheNewVersionIsOnlinePleaseUpdateToTheLatestVersion: "A new version is available. Please update to the latest version.",
TheNumberOfTheTicket: "Ticket Pickup No.",
TheOrderConfirmedAndProofOfSuccessfulBookingFollowingMethods: "Order confirmed. Booking confirmation can be obtained via the following methods.",
TheOrderIncludesAirfare: "By clicking Next, you acknowledge that you have read and agree to the",
TheOrderIncludesRescheduledPassengers: "Some passengers in this order have changed their tickets.",
TheOrderIsForIndividualPaymentOrders: "This is a personal payment order. For Change requests, please contact your corporate travel consultant or call 4006-123-123.",
TheOrderIssuedAndProofOfSuccessfulBookingFollowingMethods: "Ticket issued. E-ticket confirmation can be obtained via the following methods.",
TheOrderIssuedAndProofOfSuccessfulBookingFollowingMethodsForTrain: "Ticket issued. Train ticket confirmation can be obtained via the following methods.",
ThePeriodOfValidity: "Validity Period",
ThePeriodOfValidityTips: "E.g., enter 0625 for June 2025",
ThePhoneNumberIsTheSameAsTheCurrentlyBoundMobilePhoneNumber: "This mobile phone is the same as the currently linked number.",
TheRailwayBureauStipulatesThatTicketsMustBeSoldByRealName: "Real-name registration is required for railway ticket purchases.",
ThereAreOtherFlightsAtTheSameTime: "There are other flights available during the same time period. Do you want to continue?",
TheReasonForExceedingTheStandardCannotExceedXWords: "The reason for exceeding Travel Standard cannot exceed 50 characters.",
TheRefundFeeIsBeingApprovalByTheFlightCompany: "Refund fee is under airline review",
TheRefundFeeIsSubjectToTheReviewOfTheAirlineCompany: "The final refund fee is subject to the airline's review.",
ThereMustBeNoContactWithTheSamePhoneNumber: "Duplicate contact phone numbers are not allowed.",
ThereNoAvailableRoomTypesForBooking: "Not available",
ThereNoAvailableRoomTypesForBookingForChangeFilter: "No matching room types found. Try changing your filters.",
TheRescheduleType: "Change Type",
TheReschedulingFeeIsBeingApprovalByTheFlightCompany: "Change fee is under airline review",
TheReschedulingFeeIsSubjectToTheReviewOfTheAirline: "The final Change fee is subject to the airline's review.",
TheRoomerIDNumberCannotBeRepeated: "Guest ID numbers cannot be duplicated.",
TheRoomIsReservedAllNight: "The room will be held all night. Room may not be ready if you arrive before 14:00.",
TheSpecificPriceIsSubjectToTheReview: "*The exact price is subject to 12306 verification.",
TheSpecificRefundAndChangeRulesShallBeSubjectToTheDateOfTheTicketIssue: "The exact Refund and Change rules are subject to the airline's policy.",
TheSubmissionFailedPleaseTryAgainLater: "Submission failed. Please try again later.",
TheSysteIsBusyPleaseReOperate: "System busy. Please try again.",
TheSystemIsBusyPleaseTryAgainLater: "System busy. Please try again later.",
TheTakeoffAndLandingLocalTime: "Departure and arrival times are all local time.",
TheTicketYouChooseIsVeryCloseToTheDepartureTime: "The train you selected departs soon. Please ensure you have enough time for security check, identity verification, and ticket gating. Due to proximity to departure, ticketing may fail. Please pay attention to the confirmation message to avoid delaying your trip.",
TheTicketYouChooseIsVeryCloseToTheDepartureTimeChange: "The train you selected departs soon. Please ensure you have enough time for security check, identity verification, and ticket gating. Due to proximity to departure, the Change request may fail. Please pay attention to the confirmation message to avoid delaying your trip.",
TheTotalBudgetAmountHasChanged: "The total budget amount has changed.",
TheValidityPeriodHasExpired: "Expired",
TheValidityPeriodHasExpiredByReplace: "Your ID has expired. Please choose another ID or renew it before booking.",
ThinkAgain: "Cancel",
ThinkCompleted: "Thinking completed",
Thinking: "Thinking",
ThirdPartyBinding: "Link Third-Party Account",
ThirdPartyRelation: "Link Account",
ThirdStep: "Step 3",
ThisInformationIsForReferenceOnlyIfThereIsAnyChangePleaseReferToTheStationAnnouncement: "*For reference only. Please refer to station announcements for updates.",
TicketAmount: "Ticket Amount",
TicketBarrier: "Ticket Gate",
TicketBarrierWaitingPlace: "Ticket Gate/Waiting Area",
TicketBookingAuthority: "Domestic Flight Travel Standard",
TicketChangeRefund: "Changes & Refunds",
TicketContent: "Ticket Content",
TicketFare: "Ticket fare",
TicketingMail: "Confirmation Email",
TicketingSMS: "Confirmation SMS",
TicketingSucceed: "Issued",
TicketNumber: "Ticket No.",
TicketPricesHaveChanged: "Fare Changed",
TicketRestrictions: "Changes & Refunds",
TicketRestrictionsArrow: "Changes & Refunds >",
TicketRestrictionsCancellationBaggage: "Changes & Refunds | Baggage",
TicketRestrictionsCancellationBaggageArrow: "Changes & Refunds > Baggage >",
TicketRestrictionsRule: "Change & Refund Policies",
Tickets_1: "/Ticket",
TigerRobot: "Xiaohu Robot",
Time: "Redemption Period",
Time_1: "Time",
TimeConsuming: "Duration",
TimeConsumingLeast: "Duration (Shortest)",
TimeConsumingMost: "Duration (Longest)",
TimeDeparture: "Departure Time",
TimeHighToLow: "Time: Late to Early",
TimeLowToHigh: "Time: Early to Late",
TimeRange: "Time Range",
Tips: "Note",
Tips_1: "[Note]",
Tips_2: "Note",
TipsColon: "Note: ",
TMS: "Homsom Hotel TMS",
TMSOnline: "Homsom Hotel TMS Online",
ToApply: "Request",
ToBeConfirmed: "Pending",
ToBeIssued: "To Be Invoiced",
ToBetterYourBusinessTripExperience: "To ensure a premium hotel experience during your business trip",
ToChoose: "Select",
Today: "Today",
ToDo: "To-Do",
ToEnsureThatThePassengerInformationIsCorrect: "Please verify as prompted to ensure passenger information is correct.",
ToEnsureTheSecurityOfTheAccount: "To protect your account, please confirm that this is your action.",
ToGuarantee: "Guarantee",
ToGuaranteeAmount: "Guarantee Amount",
ToModify: "Edit",
Tomorrow: "Tomorrow",
Tomorrow_1: "Next Day",
Top5Cities: "Top 5 Cities",
Top5CostCenterExpense: "Top 5 Cost Centers",
Top5DeptsExpenses: "Top 5 Departments",
Top5DestinationsbyExpense: "Top 5 Destinations",
TopFiveModels: "Top 5 Vehicle Models",
ToSetUp: "Go to Settings",
Total: "Total",
Total_1: "Total Round-Trip Price:",
Total_3: "Total Round-Trip Price",
TotalAmount: "Total Amount",
TotalAmount_1: "Total Spend",
TotalAmountOfCarUsed: "Total Ride Amount",
TotalAmountOfTrainTicket: "Total Train Amount",
TotalAmountPendingApproval: "Total Pending Amount",
TotalBudget: "Total Budget",
TotalBudgetAmount: "Total Budget Amount",
TotalBudgetRMB: "Total Budget (CNY)",
TotalDuration: "Total Duration",
TotalMileage: "Total Mileage",
TotalMissedSaving: "Total Missed Savings",
TotalNumberOfPeople: "Total Travelers",
TotalOrderAmount: "Total Order Amount",
TotalPrice: "Total",
TotalPriceIncludingTax: "Taxes & fees included",
TotalPriceIncludingTax_1: "Total Price (Taxes & Fees Included)",
TotalPriceNoTax: "Excl. tax",
TotalPriceNoTax_1: "Total Round-Trip Price (Excl. Tax)",
TotalPriceNoTax_2: "Multi-Trip Total Price (Excl. Tax)",
TotalPriceTax: "Incl. tax",
TotalPriceTax_1: "Total Round-Trip Price (Incl. Tax)",
TotalPriceTax_2: "Multi-Trip Total Price (Incl. Tax)",
TotalSaving: "Total Savings",
ToTravel: "Upcoming",
TouchIDIsNotEnabled: "Fingerprint ID not enabled on this device",
TouchIDIsOnlyValidForTheMachine: "Fingerprint ID is only valid on this device",
TouchIDLogin: "Fingerprint Login",
TourismConference: "Leisure Travel",
Traffic: "Transportation",
Train: "Trains",
TrainAccount: "12306 Account",
TrainAccountIdVerify: "12306 ID Verification",
TrainAccountIdVerifySuccess: "Identity verification successful",
TrainAccountLogin12306: "Log in to 12306",
TrainAccountName: "Username",
TrainAccountPwd: "Password",
TrainAccountPwd12306: "12306 Account & Password",
TrainAccountSubmitCheck: "Submit for Verification",
TrainApplication: "Train Ticket Request",
TrainBookPermission: "Train Booking Permissions",
TrainChanged: "Train schedules may have changed. Please search again.",
TrainDetails: "Train Details",
TrainNumber: "Train No.",
TrainOrders: "Train Orders",
TrainPickupDropoff: "Train Station Transfer",
TrainPreferQuietCoach: "Prefer Quiet Car",
TrainQuietCoachKey: "Quiet Car",
TrainRank: "Train Travel Standard",
TrainSeatHoldingDefaultDesc: "Verifying 12306 login status and locked order data. Results will be available in 1-3 minutes. Please wait.",
TrainSnatchCode: "Alternative Trains",
TrainSnatchDate: "Alternative Dates",
TrainSnatchDeadline: "Deadline",
TrainSnatchSeats: "Alternative Seats",
TrainStation: "Railway stations",
TrainTicket: "Trains",
TrainTicketChange: "Train Ticket Change",
TrainTicketConfirmation: "Train Order Confirmation",
TrainTicketFare: "Train Fare",
TrainTicketLatitude: "Train Ticket Latitude",
TrainTicketRefund: "Train Ticket Refund",
TrainTicketsYouSearchedFor: "Search History",
TrainType: "Type Of Train",
Transfer: "Transfer",
TransferToAnotherStation: "Station Change Transfer",
TransportationAccommodation: "Travel & Accommodation",
TravelApplication: "Travel Request",
TravelApplicationCode: "Travel Request No.",
TravelBooking: "Book Travel",
TravelCard: "Frequent Flyer Card",
TravelControl: "Travel Policy Control",
TravelDataAnalysis: "Travel Analytics",
TravelDate: "Travel Date",
Traveler: "Traveler",
Traveler_1: "Staff",
TravelerDetails: "Traveler details",
TravelerName: "Name",
TravelerNameDesc: "Ensure name matches ID.",
TravelerType: "Traveler Type",
TravelPolicy: "Travel Standard",
TravelPositioning: "Travel Policy Profile",
TravelPurpose: "Purpose of Trip",
TravelReminder: "Travel Reminders",
TravelReminderColon: "Travel Reminders:",
TravelReport: "Travel Reports",
TravelSecurity: "Travel Insurance",
TravelStandard: "Standard",
TravelStandard_1: "My Travel Standard",
TravelTime: "Travel time",
TravelType: "Travel Category",
Trip: "Itinerary",
TripAssistantDesc: "Trip Assistant can plan your itinerary based on requests",
TripIncludeLegalHoliday: "Trip includes public holidays.",
TripType: "Trip Type",
TryAgain: "Retry",
TryAgain_1: "Retry",
TryAIFillApplication: "Let AI fill your business trip request",
TWD: "TWD",
TwinBed: "Twin Bed",
Type: "Type",
Type_1: "Reason Type",
TypeOfQuestionRequired: "Inquiry Type (Required)",
TypeOfTrip: "Trip Type",
UnableToBookTheCurrentAgreementPriceProduct: "Sorry, the passenger is not on the airline's whitelist and cannot book this Negotiated fare product.",
UnableToLocateCurrentCity: "Unable to determine current location",
UnbindSuccessfully: "Unlinked successfully",
UnbindTitle: "Unlink",
Unbound: "Not Linked",
UnboundApprover: "No designated approver assigned",
UnboundCustomization: "No custom fields linked",
UnboundEmployees: "Unlinked Staff",
UnboundTemplate: "No template linked",
UnderOneYearOld: "Under 1 year old",
UnderTheCurrentCostCenterNoCostCenter: "No sub-cost centers under the current cost center.",
Uneditable: "Non-editable",
Unfilled: "Not filled in",
Unfinished: "Ongoing",
Unfold: "Expand",
UnhookYourFingersAndCancelSend: "Release to cancel",
UnissuedTicketAmount: "Unissued Ticket Amount",
Unit: "Company",
UnitAbbreviation: "Company Abbreviation",
UnitAccount: "Corporate Account",
UnitEntry: "Corporate Portal",
UnitLogo: "Company Logo",
UnitManagement: "Company Management",
UnitName: "Company Name",
UnitNumber: "Company ID",
UnitNumberOrUnitName: "Company ID or Company Abbreviation",
Unknown: "Unknown",
Unmodifiable: "Non-modifiable",
Unselected: "Not selected",
UnStaffAdd: "Add External Personnel",
Unsubmitted: "Not submitted",
Untie: "Unlink",
Update: "Update Now",
Update_1: "Update",
UpdateSearchWhenPullingMap: "Search as I move the map",
Upgrading: "Updating...",
UploadCertificate: "Upload Proof",
UploadedCertificate: "Proof uploaded",
UploadFile: "Upload File",
UrbanCivision: "City Tiers",
USD: "United States Dollar",
UseCarCity: "City",
UseCarDate: "Date",
UsedForCheckingInAtTheHotelFrontDeskOrForProcessingDestinationVisas: "Required for hotel check-in or visa applications.",
UseLxd: "Use",
UserCanceled: "Cancelled by User",
UserName: "Username",
UserNameEmailMobile: "12306 User Name/Email/Mobile Phone",
UseRules: "Terms of Use",
UseTheCarImmediately: "Ride Now",
UseTravelCardTipsEnsureIdentityMatch: "· Ensure the ID document linked to your Frequent Traveler Card matches the ID document used for boarding.",
UseTravelCardTipsMilesDecidedByAirline: "· Actual mileage and points accrual are subject to the airline's policies.",
UseTravelCardTipsNoAutoMilesAccumulation: "Frequent flyer mileage accrual is not supported for this flight.",
UseTravelCardTipsPartialFlightsNotSupport: "· Mileage accrual is not supported for some flights in this itinerary.",
UsingTheAppFaceRecognitionIsMoreAccurateAndFaster: "Use the App for faster and more accurate facial recognition",
UsingTheLastestVersion: "You are on the latest version.",
ValidPeriod: "Expiration Date",
VehicleDisinfection: "Disinfected",
VehicleTrack: "Route History",
VerificationCode: "Code",
VerificationCodeAgain: "Resend Code",
VerificationCodeAgain_1: "Resend",
VerificationCodeCheck: "Please enter the SMS verification code",
VerificationCodeCheckFail: "Incorrect verification code",
VerificationCodeCoped: "Verification code copied",
VerificationCodeCopiedSuccessful: "Copied",
VerificationCodeFailedToSend: "Failed to send verification code",
VerificationCodeGet: "Send Code",
VerificationCodeHasBeenSent: "Verification code sent",
VerificationFail: "Verification Failed",
VerificationInProgress: "Verifying",
VerificationPass: "Verified",
VerificationPassLoginSuccess: "Verified successfully. Logging in...",
VerificationSucceeded: "Verification successful",
VerificationSuccessful: "Verification Successful",
VerifiedPhoneNumber: "Verified Mobile Number",
VerifyUsingMail: "Verify via Email",
VerifyUsingPhoneNumber: "Verify via Mobile",
VerifyVehicleBeforeBoarding: "Please verify vehicle details before boarding.",
VersionNumber: "Version",
VersionUpdate: "Update Version",
ViewAllStaff: "View All Staff",
ViewBookPermissions: "View/Book Permissions",
ViewComments: "View Comments",
ViewComments_1: "View Reviews",
ViewConfirmNumber: "View Confirmation",
ViewDesignatedDepart: "View Designated Departments",
ViewDesignatedStaff: "View Designated Staff",
ViewDetailedProcedure: "View Details",
ViewDirectTicket: "View Non-stop Train Tickets",
ViewElectronicPolicy: "View Policy",
ViewHelpDocs: "Help Center",
ViewHistoricalApplys: "Past Requests",
ViewHistoricalOrders: "Past Orders",
ViewHistoryChat: "Chat History",
ViewItineraryTrack: "Trip History",
ViewMoreCountriesOrRegions: "View More Countries/Regions",
ViewMoreFlights: "View more flights",
ViewMoreHotel: "View more hotels",
ViewMoreTrains: "View More Trains",
ViewMoreTransferSchemes: "View Layover Options",
ViewOnlySelf: "Viewable only by the owner",
ViewOrder: "View",
ViewPermissions: "View Permissions",
ViewReimbursementVoucher: "View Reimbursement Documents",
ViewReservation: "View Order",
ViewRoomType: "View room types",
ViewSample: "View Sample",
ViewTheBigMap: "View Larger Image",
ViewTheLowestPrice: "Lowest-Priced Flights",
ViewTravelApplicationForm: "View Trip Request",
ViolationOfBusTravelRank: "Reason for out-of-policy bus ticket booking",
ViolationOfCarTravelRank: "Reason for out-of-policy car booking",
ViolationOfHomsomTravelStandardsNotSelectable: "Travel Standard violation; selection unavailable",
ViolationOfHomsomTravelStandardsSelectedReason: "Travel Standard violation - Select a reason:",
ViolationOfHotelTravelRank: "Reason for out-of-policy hotel booking",
ViolationOfMealsTravelRank: "Reason for out-of-policy meal expense",
ViolationOfRank: "Out of Policy",
ViolationOfRankDetail: "Policy Violation Details",
ViolationOfTrainTravelRank: "Reason for out-of-policy train ticket booking",
ViolationOfTravelRank: "Out of Policy",
VirtualNumberProtection: "Virtual number protection to prevent mobile number disclosure",
Visa: "Visa",
VisaCountryOrRegion: "Visa Countries/Regions",
VisaDetails: "Visa Details",
VisaIssuanceEmail: "Visa Issuance Email",
VisaIssuanceShortMessage: "Visa Issuance SMS",
VisaOrder: "Visa Orders",
VisaSubmissionEmail: "Visa Submission Email",
VisaSubmissionShortMessage: "Visa Submission SMS",
VisaType: "Visa Type",
VoiceTooShort: "Voice message too short",
VoidApplicationForm: "Cancellation Request",
VoidedFailed: "Cancellation Failed",
VoidedSuccessfully: "Cancelled successfully",
VoluntaryRefund: "Voluntary Refund",
VoluntaryRefundDesc: "Voluntary Refund (Subject to airline refund policies)",
VoluntaryRefundExplain: "Voluntary Refund Policy",
VoluntaryReschedule: "Voluntary Change",
VoluntaryRescheduleDesc: "Voluntary Change (Subject to airline change policies)",
VoluntaryRescheduleExplain: "Voluntary Change Policy",
Voucher: "Voucher",
WaitingForConfirmation: "Awaiting Confirmation",
WarmTipsWhitelistedEmployees: "Note: Whitelisted staff do not require approval.",
WarmTipTheModificationIsNotSupportedForTheTimeBeing: "Note: Editing is temporarily unsupported. For changes, please contact your dedicated consultant.",
Wechat: "WeChat",
WeChat_Limit_1: "Due to Mini Program limitations, please complete this action in the Homsom app or website.",
WechatByAccount: "WeChat Work Account",
WechatByUser: "WeChat Work Staff Linking",
WechatIsNotInstalled: "WeChat is not installed",
WechatNotSupportDDPleaseUseAppOrH5: "Didi service is not supported in the WeChat Mini Program. Please use the app or H5 to book.",
WechatNotSupportOnlineCheckInPleaseOpenOnPcOrApp: "Online check-in is not supported in the WeChat Mini Program. Please use PC, the app, or H5.",
WechatPay: "WeChat Pay",
WeekFri_1: "Fri",
WeekMon_1: "Mon",
WeekSat_1: "Sat",
WeekSun_1: "Sun",
WeekThur_1: "Thu",
WeekTues_1: "Tue",
WeekWed_1: "Wed",
Welcome: "Hi, welcome!",
WelcomeBackChat: "Welcome back. Let’s talk about something new.",
WelcomeToDidi: "Welcome to DiDi",
WelcomeToHOMSOM: "Welcome to Homsom",
WelcomeToHumanCustomerService: "Welcome to Live Chat",
WelcomeToLogin: "Welcome!",
WelcomeToLoginHomsom: "Welcome to Homsom",
WelcomeToUseIt: "Welcome",
WhatIsEnterpriseCode: "What is Corporate Code?",
WhereWouldYouLikeToGo: "Where to?",
WhetherToAcceptTheSeatlessTicket: "Accept unreserved/no-seat tickets if selected seat type is unavailable?",
WhetherToConfirmTheDeletionOfThisFavoriteContact: "Are you sure you want to delete this frequent contact?",
WhetherToConfirmThePasswordChange: "Are you sure you want to change your password?",
WhetherToConfirmTheRefund: "Are you sure you want to request a refund?",
WhetherToSendARefundEmail: "Send refund confirmation email?",
WhetherToSendARefundEmail_1: "Send Refund Email",
WhetherToSendARefundSuccessfulMail: "Send refund confirmation email?",
WhetherToSendARefundSuccessfulMail_1: "Send Refund Confirmation Email",
WhetherToSendARefundSuccessfulSMS: "Send refund confirmation SMS?",
WhetherToSendARefundSuccessfulSMS_1: "Send Refund Confirmation SMS",
WhyOpenEnterpriseCode: "Why use Corporate Code?",
WhyOpenEnterpriseCodeDescription: "Once Corporate Code is activated, you can select Corporate Payment (Homsom) when booking train tickets. Expenses are paid directly via Homsom's corporate Alipay account, eliminating the need for staff to pay out of pocket.",
Window_1: "Window Seat",
WindowType: "Window",
Withdrawal: "Withdraw",
WriteReasonCode: "Enter Reason Code",
YearOnYear: "YoY",
Yesterday: "Yesterday",
Yesterday_1: "Yesterday",
YouAlsoHaveUnselectedPassengers: "Please complete seat selection for all passengers before submitting the order.",
YouAreUsingAggregationPlatform: "You are using an aggregation platform",
YouAreUsingDiDiPlatform: "You are using the DiDi platform",
YouCanDoTheFollowing: "Available Actions",
YouCannotSelectContactsWithTheSamePhoneNumberAtTheSameTime: "Cannot select multiple contacts with the same mobile phone.",
YouCanOnlyGetSMSVerificationCodesFor3MobilePhoneChecksPerDay: "*Maximum of 3 SMS verification codes per day for phone verification.",
YouCanOpenItInMySettingSecurityManager: "You can enable this in Account > Settings > Security.",
YouCanUseFaceIDVerification: "Enable Face ID for faster login.",
YouCanUseTouchIDVerification: "Enable Touch ID for faster login.",
YouHaveACarOrderInProgress: "You have an active ride order.",
YouHaveToDoFaceRecognitionAlone: "Please ensure only one person is in frame for facial recognition.",
YouHaveUnselectedPassengersPleaseSubmitAfterSeatSelection: "Please complete seat selection for all passengers before submitting.",
YouNeedToPayViaAlipay: "Please complete payment via Alipay",
YouNotCompletedTheTrainTicketIdentityVerification: "ID verification for train tickets is incomplete. Verify now?",
YourApplyHasNotBeenFilledOut: "Your business trip request is incomplete. Are you sure you want to leave?",
YourCompanyAllowsYouToPayTheExtraAmountForAnOutPolicyHotelByCreditCardWeChatOrAlipay: "Out-of-policy amounts can be paid personally via WeChat Pay or Alipay.",
YourCurrentLoginAccountNeedsMobilePhoneNumberVerification: "Mobile number verification required for your account.",
YourDateOfBirthGenderNationalityAndIDCardDoNotMatch: "Your details do not match your ID card and have been auto-corrected.",
YourDateOfBirthGenderNationalityAndIDCardDoNotMatch_1: "Your details do not match your ID card.",
YourExclusiveTravelConsultant: "Your Dedicated Travel Consultant",
YourHotelGroupMembershipCard: "Hotel Membership Card",
YourOrderHasNotBeenCompletedOut: "Your order is incomplete. Are you sure you want to leave?",
YourOrderHasNotBeenFilledOut: "Your order is incomplete. Are you sure you want to leave?",
YourPhoneNumberHasNotBeenRegisteredYet: "This mobile phone is not registered.",
YourStayIsTooLongTheFlightAndPriceInformationMayChangeAndTheLatestPrice: "Due to your extended stay, flight and price information may have been updated. We are now retrieving the latest information for you.",
YourTravelCard: "Frequent Flyer Program",
YouWill: "You will get",
YouWillFrom: "You will start from",
About: "≈",
And: "and",
Avg: "Avg.",
B: "B",
BackTag: "Return",
Below: "D",
Book: "Book",
By: "Stop",
Change_1: "Change",
CN: "CN",
Copy: " Copies",
Cross: "Via",
D: "Dep",
E: "Arr",
EN: "EN",
Female: "Female",
First: "No.",
Floor: "F",
From: "Up",
GoTag: "Dep",
Home_1: "Home",
In: "C/I",
Male: "Male",
Month: "Mon",
NoHistoryChat: "No chat history. Start a conversation.",
None: "None",
Original: "Orig",
Out: "C/O",
P: "P",
Page: "Page",
QuantifierHotel: " Rms",
QuantifierNight: " Night",
QuantifierPeople: " Ppl",
R: "Refund",
Rest: "Rest",
RMB: "CNY",
Save_1: "Save",
ScoreByComments: "Pts",
Snatch: "Grab",
Stop_1: "Stop",
Tax: "Tax",
Tickets: "Ticket(s)",
To: "To",
TrainAvailable: "Available",
TrainQuietCoach: "Quiet",
Transfer_1: "Transfer",
Unit_1: "Qty",
Upper: "Dep",
WeekFri: "Fri",
WeekMon: "Mon",
WeekSat: "Sat",
WeekSun: "Sun",
WeekThur: "Thu",
WeekTues: "Tue",
WeekWed: "Wed",
Window: "Window",
Work: "Work",
Year: "Year",
You: "You",
AccountProtocol_2_x: "Your name, mobile number, and ID will be used for 12306 account recovery and verification. For details, see %a$.",
AccountProtocol_3_x_x: "Per the Measures for Real-Name Railway Tickets, valid ID information is required for ticket booking and services. It will be used for booking, boarding, Changes/Refunds, and invoice printing. Please ensure data accuracy to avoid service disruptions. We secure your personal data via encryption and share it with necessary third parties only for transaction processing. For details, see %a$%b$",
ActualTotalPrice_x: "Actual cost: %a$",
AddDay_x: "+%a$ day(s)",
Adults_1_x: "%a$ Adult(s)",
Adults_Children_x_x: "%a$ Adult(s) %b$ Child(ren)",
Adults_x: "%a$ Adult(s)",
Age_x: "Age %a$",
AIAssistantIntro_x: "I am %a$’s AI travel assistant.",
AirportDropOff_x: "%a$ Airport Drop-off",
AirportPickup_x: "%a$ Airport Pickup",
AllTime_x: "Duration: approx. %a$",
AllTime_x_x: "%a$, approx. %b$",
ApplicationContent_x: "Request Details: %a$",
Approval_x: "%a$ Approval",
ApprovalTimeoutNoticeTime: "Approval timeout notification: %a$ min",
AreYouSureToDelete_x: "Are you sure you want to delete %a$?",
AreYouSureToRemove_x: "Are you sure you want to remove this %a$?",
AreYouSureYouWantToGiveUpTheInformationChange_x: "Changes have been made to %a$. Discard changes?",
AToB_x_x: "%a$ to %b$",
AttachFileUpload_x: "Up to %a$ more file(s) can be uploaded",
Available_x: "%a$ Available",
Baby_1_x: "%a$ Infant(s)",
Baby_x: "%a$ Infant(s)",
BackWeek_x: "Back to %a$",
BaggageAllowance_x: "Baggage Policy: %a$",
BasicInformationIsIncompletePleaseEdit_x: "Incomplete basic info for %a$, please edit",
BecomeDue_x: "Expires on %a$",
BedWide_x_x: "Width: %a$ x %b$",
BindMembershioFor_X: "Link %a$ Membership Card",
BindPerson_x: "%a$ Linked",
BookDesignated_x: "Book for designated %a$",
BookPwdRemainingAttempts_x: "%a$ attempts remaining. If you forgot your booking password, please retrieve it.",
Budget_1_x: "%a$ Budget",
Budget_x: "%a$ Budget",
Business_x: "%a$ (Business)",
CanAccommodateUpToXPeople_x: "Max %a$ guest(s) per room",
CanOnlySelectUpToXGuest_x: "You can only select up to %a$ guest(s) per room",
CanOnlySelectUpToXpassengers_x_x: "You can only select up to %a$ %b$",
CanPeopleStaying_x: "Max %a$ guest(s)",
CarUseEndDate_x: "Ride service end date can be extended to: %a$",
CarUseStartDate_x: "Ride service start date can be advanced to: %a$",
ChangeStationWarn_1_x_x: "Your departure station has changed from %a$ to %b$. Do you want to continue?",
ChangeStationWarn_2_x_x: "Your arrival station has changed from %a$ to %b$. Do you want to continue?",
ChangeStationWarn_x_x_x_x: "Departure changed from %a$ to %b$, arrival from %c$ to %d$. Continue?",
ChangeTheNumberOfPeople_x: "Travelers updated to %a$. You can manually edit if needed.",
ChangeTheNumberOfRoomsAndPeople_x_x: "Guests updated to %a$ room(s), %b$ guest(s). Modify manually if needed.",
ChangeTo_x: "Change to %a$",
ChargebackNumber_x: "Refund No. %a$",
CheckIn_x: "Check-in: %a$",
CheckInCheckOut_x_x_x: "Check-in: %a$, Check-out: %b$, %c$ Night(s)",
CheckInDate_x: "Check-in date can be advanced to: %a$",
CheckInToCheckoutNight_x_x_x: "%a$ to %b$, %c$ Night(s)",
CheckInToCheckoutNight_x_x_x_x_x: "Check-in: %a$ %b$, Check-out: %c$ %d$, %e$ Night(s)",
CheckInToCheckoutNightAndRoom_x_x_x_x: "%a$ to %b$ · %c$ night(s), %d$ room(s)",
CheckInToCheckoutNightAndRoomAndRoom_x_x_x_x_x: "%a$ to %b$ · %c$ night(s), %d$ room(s) · %e$",
CheckOut_x: "%a$ Check-out",
CheckOutDate_x: "Check-out date can be extended to: %a$",
Children_1_x: "%a$ Child(ren)",
Children_x: "Child(ren) %a$",
ChName_x: "Chinese Name: %a$",
ChNameToPinyin_x: "Convert '%a$' to Pinyin",
Choose_x: "Please select %a$",
ChooseAtLeastXPeople_x: "Please select at least %a$ guest(s).",
ChooseAtMostContact_x: "You can select up to %a$ contact(s).",
ChooseUpToXPeople_x: "You can select up to %a$ guest(s).",
CNYStart_x: "From %a$",
CompanyAndPersonalPayment_1_x_x: "Company Paid: %a$, Personal Paid: %b$",
CompanyAndPersonalPayment_x_x: "Company: %a$ Personal: %b$",
ConfirmFollow_x: "Confirmed Followers (%a$)",
ConfirmImportTraveler_x: "Confirm Import (%a$)",
ConfirmSelectedTraveler_x: "Confirm Selection (%a$)",
ContactEmailFormatIsIncorrect_x: "The email format for contact %a$ is incorrect.",
ContactInformationOfExclusiveConsultant_x: "Contact information for dedicated advisor %a$",
ContactMobileFormatIsIncorrect_x: "The mobile number format for contact %a$ is incorrect.",
Contacts_x: "Contact: %a$",
ContactTheEmailNotificationHasBeenTurnedOn_x: "Email notification is enabled for contact %a$. Email address cannot be empty.",
ContactTravelAdvisorOrCall_x: "Please contact your dedicated travel advisor or call %a$ to book.",
ConvertToPinyin_x: "Convert '%a$' to Pinyin",
CountFormat_x: "%a$",
CurrencyExplain_x: "Currency: %a$ Price per adult",
CurrentBoundAccountPrefix_x: "Current Linked Account: %a$",
CurrentOrderGeneratedOrder_x: "%a$ order(s) generated for the current booking.",
CurrentOrderGeneratedOrderYouNeedToPayInTurn_x: "%a$ order(s) generated for the current booking. Please pay them in sequence.",
CurrentPhoneNumberTip_x: "Current mobile number is %a$. Please enter the new mobile number and verify it.",
Departure_x: "%a$ Departure",
DepartureCityAndArrivalCityCannotBeSame_x: "The departure and arrival cities for segment %a$ cannot be the same.",
DepEndDate_x: "Departure end date can be extended to: %a$",
DepStartDate_x: "Departure start date can be advanced to: %a$",
DesignatedDepartment_x: "Designated %a$",
DistanceCenter_x_x: "%b$ from city center %a$",
DistanceFromYou_x: "%a$ from you",
DistanceToDestination_x: "%a$ to destination",
Download_x: "Download %a$",
Downloading_x: "Downloading... %a$%",
EachRoomNeedsToFillIn_x: "Please enter %a$ guest(s) for each room",
EconomyClassDiscountBelow_x: "Economy Class (%a$ discount or less)",
Edit_x: "Edit %a$",
ElectronicInvoiceReissueLimit_x: "Electronic invoices can only be reissued %a$ time(s). Please fill in the invoice information carefully.",
EmailFormatIsIncorrect_x: "The email format for %a$ is incorrect.",
EstimatedWaitingTime_x: "Estimated wait time: %a$ min",
ExclusiveConsultant_x: "Dedicated Advisor: %a$",
ExistingStaff_x: "Existing Employees (%a$)",
FileSizeLimit_x: "Files must be under %a$ MB.",
FldReward_x: "%a$ Voucher Beans",
Flight_x: "%a$ Flights",
FlightNo_x: "Flight No. %a$",
Floor_x: "%a$F",
FlyingTime_x: "Flight Duration %a$",
GoingAndReturnTicket_x_x: "%a$ (Depart), %b$ (Return)",
GoingTicket_x: "%a$ (Depart)",
GoTo_x: "Go to %a$",
GoToMixedPay_x: "Out-of-Policy Payment %a$",
GoToPay_1_x: "Pay %a$",
GoToPay_x: "Pay %a$",
GoToTheStoreBeforeOClock_x: "Arrive before %a$",
GuestRoom_x: "Room %a$",
Hotel_x: "%a$ Hotels",
HotelChargeByPersonCountTip_x: "%a$ rates depend on guest count. Please enter the exact number of adults and children.",
HotelCheckInPost_x: "Check-in after %a$",
HotelCheckOutBefore_x: "Check-out before %a$",
HotelFillRoomGuestOptional_1_x: "Fill in guest for Room %a$",
HotelFillRoomGuestOptional_x: "Fill in guest for Room %a$ (Optional)",
HotelRefundRoomNight_x_x: "%a$ Rooms · %b$ Nights Refunded",
IHaveReadAndAgree_x: "I have read and agree to %a$",
Index_x: "%a$ Trip",
Intergral_x: "%a$ Points",
IntergralDeliveryNumber_x: "Tracking No.: %a$",
Interval_x: "Interval %a$",
Inventory_x: "Stock: %a$",
InvoiceDetailsCount_x: "Total Invoices: %a$",
IsNotAArrivalCity_x: "%a$ cannot be selected as a destination city",
IsNotADepartureCity_x: "%a$ cannot be selected as a departure city",
ItineraryInfo_x: "Itinerary Info %a$",
ItIsNowPastZeroOclock_x: "It is past 0:00 AM. If you are checking in before %a$ AM, please select 'Early Morning' check-in.",
JudgeCertificateExpired_x: "%a$ Your ID expires within 6 months of departure, which may prevent you from boarding. Do you wish to continue?",
KeySelectedCarTypes_x: "%a$ vehicle types selected",
LengthMustNotExceedXDigits_x_x: "%a$ length cannot exceed %b$ digits",
LevelXAapproval_x: "Level %a$ Approval",
LimitedToXReservation_x: "Only available for %a$ booking",
LocalTimeOfTheDepartureCity_x: "Flight %a$, please use origin local time",
Login12306AccountInPerson_x: "Please confirm you are verifying your identity: %a$",
LowestPriceHoursAndTicket_x_x: "Lowest price within %a$ hours: %b$/ticket",
LxdReward_x: "%a$ Travel Beans",
LxdToCompleteTheOrder_x: "Earn %a$ Travel Beans upon order completion",
Manage_x: "%a$ Management",
MaxOnlyUseFld_x: "A maximum of %a$ Voucher Beans can be used",
MaxSelectableOrders_x: "Select up to %a$ items",
MaxUseFld_x: "Up to %a$ Voucher Beans can be used",
MergeIssueReimbursableAmountInfo_x_x_x: "Includes %a$ primary and %b$ change/refund orders; combined reimbursable amount is %c$",
Minute_x: "%a$ min",
MixedPaymentContent_x_x_x: "Your order total is %a$. The maximum travel standard is %b$, exceeding by %c$. You can choose Out-of-Policy Payment for the excess, or have the entire amount paid by the company.",
MixedPaymentDetails_x_x: "The company will pay %a$, and the individual needs to pay the amount exceeding the travel standard: %b$",
MonthsCount: "%a$ months",
MoreAvailable_x: "Valid on orders over ¥%a$",
Name_x: "%a$ Name",
NearlyMonthApply_x: "Requests in the past %a$ months",
NearlyMonthOrder_x: "Orders in the past %a$ months",
New_x: "Add %a$",
NightsTotalPrice_x: "Total for %a$ Nights",
NoMoreApply_x_x: "Showing requests from %a$ to %b$",
NoMoreOrder_x_x: "Showing orders from %a$ to %b$",
NoXSegment_1_x: "Select Flight %a$",
NoXSegment_2_x: "Selected as Flight %a$",
NoXSegment_x: "Flight %a$",
OnlyAlternativeTrainsCanBeSelectedAtMost_x: "Select up to %a$ alternative trains.",
OnlyChineseName_x: "%a$ must be in Chinese",
OnlyEnglishName_x: "%a$ must be in English",
OnlySupportsDataWithStatisticalDateSpanOfLessThanYears_x: "Only supports data within a date range of %a$ years.",
OpenedInYear_x: "Opened in %a$",
OrderAndAmountSummary_x_x: "Total %a$ orders, Invoicable Amount: %b$",
OrderDetailTotalCount_x: "Order Details: %a$ tickets",
OrderNumber_x: "Order No. %a$",
OrdersNotSupportOnlineIssuing_x: "Currently, %a$ orders do not support online invoicing.",
Other_x: "Other: %a$",
PayAtTheStore_x: "Pay at Hotel %a$",
PayAtTheStoreAbout_x: "Pay at Hotel Approx. %a$",
PayAtTheStoreTaxesFees_x: "Excluding taxes/fees payable at hotel approx. %a$",
Pending_x: "Pending Approval (%a$)",
People_x: "%a$ Ppl",
PeopleStaying_x: "%a$ guests",
Personal_x: "%a$(Personal)",
PhoneNumberFormatIsIncorrect_x: "Incorrect mobile phone format for %a$",
Plan_x: "Original schedule %a$",
PleaseChooseOrInput_x: "Please select or fill in %a$",
PleaseChooseRouteArrivalCity_x: "Please select destination city for leg %a$",
PleaseChooseRouteDepartCity_x: "Please select departure city for leg %a$",
PleaseChooseRouteGoDate_x: "Please select departure date for leg %a$",
PleaseCompleteTheInformation_x: "Please complete the information for %a$",
PleaseCompleteTheVerificationWithinMinutes_x: "Please complete the verification within %a$ minutes.",
PleaseEnter_x: "Please enter %a$",
PleaseEnterIDNumber_x: "Please enter ID number for %a$",
PleaseEnterPhoneNumber_x: "Please enter mobile phone for %a$",
PleaseEnterThe_x: "Please enter %a$ to search",
PleaseFill_x: "Please fill in %a$",
PleaseFill_x_x: "Please fill in %a$'s %b$",
PleaseFillBudget_x: "Please fill in the budget for %a$",
PleaseFillIn_x: "Please enter %a$ name",
PleaseFillInEmail_x: "Please fill in the email address for %a$",
PleaseFillInMobile_x: "Please fill in the mobile phone for %a$",
PleaseFillInTheContactMobilePhoneNumber_x: "Please fill in the mobile phone for contact person %a$",
PleaseFillOrChoose_x: "Please fill in or select %a$",
PleaseReadAndAgreeTo_x: "Please read and agree to %a$",
PleaseReselect_x: "Please reselect %a$",
PleaseSelect_x: "Please select %a$",
PleaseSelect_x_x: "Please select %a$'s %b$",
PleaseSelectFlightChangeDate_x: "Please select the flight change date for %a$",
PleaseSelectThePassengerWhoNeedsToRefund_x: "Please select the staff for refund: %a$",
PleaseUploadAttachFile_x: "Please upload %a$",
PleaseWaitAtLocation_x: "Please arrive at %a$ early to wait for the bus",
PriceOfPerson_x_x: "%a$ x %b$ travelers",
PricePerPerson_x: "%a$/person",
Punctuality_x: "On-time rate %a$",
PurchaseXItemAtMost_x: "Limit %a$ items per purchase",
QueryDateRange_x_x: "Search Date Range: %a$ to %b$",
Ready_x: "Estimated %a$",
ReasonsForBusiness_x: "Reason for Business Trip: %a$",
RefundOrderInvoiceAmount_x_x: "Total %a$ refunds, Invoicable Amount: %b$",
RefundOrderNumber_1_x: "Refund Order No. %a$",
RefundOrderNumber_x: "Refund Order No. %a$",
ReimbursementVoucher_x: "%a$ Reimbursement Voucher",
Remaining_1_x: "%a$ items remaining",
Remaining_x: "%a$ remaining",
RemainingCount_x: "%a$ remaining",
RemainingRoom_x: "Only %a$ rooms left",
RemainingUseLxd_x: "%a$ points (1 Travel Bean = 1 RMB)",
RemainRoom_x: "%a$ rooms left",
RemoveThe_x: "Delete this %a$",
RenovatedInYear_x: "Renovated in %a$",
RequiredChoose_x: "Must select %a$ guests",
RequiredFill_x: "%a$ Required",
Resend_x: "Resend (%a$s)",
ResendAfterXSeconds_x: "Resend in %a$s",
ResendPleaseWait_x: "Resending, please wait %a$",
ReturnEndDate_x: "Return end date can be extended to: %a$",
ReturnStartDate_x: "Return start date can be brought forward to: %a$",
ReturnTicket_x: "%a$ (Return Trip)",
RMB_x: "CNY %a$",
RMBPrice_x_x: "¥%a$-%b$",
RMBPriceOver_x: "¥%a$ and above",
RMBPriceUnder_x: "Under ¥%a$",
Room_x: "%a$ Rms",
RoomAdult_x_x: "%a$ Room(s), %b$ Adult(s)",
RoomAdult_x_x_x: "%a$ Room(s), %b$ Adult(s), %c$ Child(ren)",
RoomAndNight_x_x: "%a$ Room(s), %b$ Night(s)",
RoomGuest_x: "Guests of Room %a$",
RoomNight_x_x: "%a$ Room(s), %b$ Night(s)",
RoomNightPrice_x_x: "%a$ Room(s) · %b$ Night(s)",
RoomNoXAtLeastChooseOneRoomer_x: "Room %a$: At least one guest must be selected.",
RouteDepartDateCannotBeLessThanLastRoute_x_x: "The departure time for leg %a$ cannot be earlier than the departure time for leg %b$.",
SchemIndex_x: "Option %a$",
SchemIndexSelect_x: "Option %a$ (Selected)",
Search_1_x: "Search %a$",
SecondAfter_x: "In %a$s",
SeeAll_x: "View all %a$ prices",
Segment_x: "Leg %a$",
Select_1_x: "Selected: %a$",
Select_x: "Select %a$",
Selected_Train_codes_x: "%a$ alternative trains selected",
Selected_x_x: "%a$ %b$ selected",
SelectedOrderCount_x: "%a$ orders selected",
SelectedRoomTip_x: "Room %a$ selected",
SelectedTraveler_x: "Selected: %a$",
SendSMS_x: "A verification SMS has been sent to %a$. Please enter the code.",
SendTo12306_x: "Send %a$ to 12306",
SendVerificationCodeTo12306ByMobilePhoneUpToTimesPerDay_x_x: "Use mobile number %a$ to send verification code %b$ to 12306 (up to 3 times per day).",
ServiceFeePerPerson_x: "Service fee: %a$/person",
ShareDescPaymentOnBehalf_x: "I have booked %a$ via Homsom. Could you please pay for it?",
ShareTitlePaymentOnBehalf_x: "%a$ is requesting your payment assistance",
SnatchDeadline_x: "%a$ before departure",
SnatchDeadlineHour_x: "%a$ hours before departure",
SnatchDeadlineMinute_x: "%a$ minutes before departure",
SorryCouldNotFindIt_x: "No content found for '%a$'",
SorryThereAreNoSearchResultsFor_x: "No results for '%a$'",
StationDropOff_x: "%a$ Drop-off",
StationPickup_x: "%a$ Pickup",
StatisticsBy_x: "By %a$",
Stay_1_x_x: "Layover in %a$ %b$",
Stay_2_x_x: "Transfer %a$ Layover %b$",
Stay_3_x_x: "Stopover %a$ Layover %b$",
Stay_x: "Layover %a$",
Stop_1_x: "%a$ stop",
Stop_2_x: "%a$ stop(s)",
Stop_x: "Stopover %a$",
Superior_x: "Manager: %a$",
TakesOff_x: "%a$ Departure",
TakesOffArrival_x_x: "Arrive %a$, Depart %b$",
TaxPrice_x: "Tax: %a$",
TemplateCustomItemApproval_x: "Approval workflow is determined by %a$ selected during booking.",
TheAgeOfTheChild_x: "Age of Child %a$",
TheDateOfDepartureCannotBeEarlierThanThePreviousProcess_x: "%a$ departure date cannot be earlier than previous trip.",
TheIdentityOfPassengerXHasNotBeenVerified_x: "Passenger (%a$) identity verification pending",
TheNextPageIsNotUnderOuControl_x: "You are leaving our app. Please proceed with caution. %a$",
TheVerificationCodeHasBeenSentTo_1_x: "Verification code sent to %a$",
TheVerificationCodeHasBeenSentTo_x: "Verification code sent to %a$",
ThisOrderUseFld_x: "You can use %a$ Voucher Beans for this order",
ThisOrderUseLxd_x: "You can use %a$ Travel Beans for this order",
ThJourneyIsXAndIsExpectedToTakeXMinutes_x_x: "Distance: %a$ km, Est. Time: %b$ mins",
TicketRestrictions_x: "Refund/Change from %a$",
TicketRestrictions_x_x: "Refund/Change %a$%b$",
Tickets_x: "%a$ ticket(s)",
TimesFormat_x: "%a$ time(s)",
Tomorrow_x: "Next day %a$",
Total_x: "Total: %a$",
TotalAmount_x: "Total Amount: %a$",
TotalCabinInfo_x: "%a$ flight(s)",
TotalDuration_x: "Total Duration: %a$",
TotalNights: "%a$ Night(s)",
TotalNights_1: "Total %a$ night(s)",
TotalOfDay_x: "%a$ day(s)",
TotalPiece_x: "Total %a$ piece(s)",
TotalPrice_x: "Total Price: %a$",
TotalTrip_x: "(Total %a$ trip/s)",
TrainPreferQuietCoach_x: "Prefer %a$ seat",
TrainTicketSmsVerification_x_x_x: "Please notify the passenger (%a$) to send SMS '%c$' using mobile number %b$ to 12306 within 30 minutes for verification.",
Transfer_1_x: "Transfer via %a$",
Transfer_2_x: "%a$-leg transit",
Transfer_3_x: "Transfer to %a$",
Transfer_Stop_x_x: "%a$-leg transit %b$ stop(s)",
Transfer_x: "Transit %a$",
Traveler_x: "Traveler: %a$",
TripInfo_x_x_x: "Service provided by %a$. Distance: %b$ km, estimated time: %c$ mins.",
UnbindConfirmationMessage_x: "Unlinking will disable services like %a$ Quick Login. Proceed?",
Unit_1_x: "%a$ Copies",
Unit_x: "x %a$ copies",
Unit_x_x: "%a$ x %b$ copies",
UnitNumber_x: "Org Code: %a$",
UnusedTicketTitle_x: "Passenger %a$ has an unused ticket for this route. You can change it to book the current trip. To proceed, click [Change Ticket].",
UseLxd_x: "Up to %a$ Travel Beans can be used",
UseTheCar_x: "%a$ Ride-hailing",
ValidationCertificateInformationNotPassed_x: "ID verification failed for %a$",
VerificationCodeAgain_1_x: "Verification code sent. Please check your messages. If not received, you can %a$",
VerificationCodeAgain_x: "Verification code sent. Please check your messages. If not received, you can %a$ to resend.",
ViewDesignated_x: "View assigned %a$",
ViewOtherPrices_x: "View %a$ more rates",
ViolationOfRankReason_x: "Out-of-Policy Reason: %a$",
VoiceMaxDuration_x: "Max voice duration: %a$s",
WaitingTime_x: "Wait time: %a$",
Welcome_x: "Welcome, %a$!",
Welcome_x_x: "%a$: Welcome, %b$!",
WholeRoute_x: "Entire journey %a$",
XFormatIsIncorrect_x: "Invalid %a$ format",
XHoursBeforeAndAfterTheLowestPrice_x: "Lowest price within ±%a$ hours",
XIDIsWrong_x: "(%a$) ID verification failed",
XIsUnderXyearsOld_x: "%a$ Under 12 years old",
XOfFlight_x: "Flight %a$",
XTrips_x: "%a$ trains total",
Year_x: "%a$",
YourPassengersAreFullToDelete12306_x: "Your 12306 passenger list is full. Please delete %a$ passenger(s) to complete booking.",
YuanStart_x: "From ¥%a$",
}